var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _g, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M600 458.879H0V459.179H600V458.879Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M539.88 478.188H500.136V478.488H539.88V478.188Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M397.464 481.453H387.036V481.753H397.464V481.453Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M498.936 467.051H475.908V467.351H498.936V467.051Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.78 469.066H62.9521V469.366H114.78V469.066Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.068 469.066H125.472V469.366H133.068V469.066Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M270.18 474.133H157.764V474.433H270.18V474.133Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M284.4 405.36H52.6921C50.8769 405.357 49.1371 404.634 47.8547 403.349C46.5723 402.064 45.852 400.323 45.8521 398.508V72.792C45.8679 70.9872 46.5951 69.2616 47.8758 67.9899C49.1565 66.7181 50.8872 66.0031 52.6921 66H284.4C286.217 66 287.96 66.7219 289.245 68.0069C290.53 69.2919 291.252 71.0347 291.252 72.852V398.508C291.252 400.325 290.53 402.068 289.245 403.353C287.96 404.638 286.217 405.36 284.4 405.36ZM52.6921 66.24C50.9564 66.2432 49.293 66.9349 48.0668 68.1633C46.8407 69.3917 46.152 71.0564 46.1521 72.792V398.508C46.152 400.244 46.8407 401.908 48.0668 403.137C49.293 404.365 50.9564 405.057 52.6921 405.06H284.4C286.137 405.057 287.801 404.366 289.03 403.137C290.258 401.909 290.949 400.245 290.952 398.508V72.792C290.949 71.0553 290.258 69.3906 289.03 68.1625C287.801 66.9345 286.137 66.2432 284.4 66.24H52.6921Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M543.972 405.36H312.252C310.436 405.357 308.695 404.634 307.41 403.35C306.126 402.065 305.403 400.324 305.4 398.508V72.792C305.419 70.9861 306.149 69.2605 307.431 67.9891C308.714 66.7177 310.446 66.0031 312.252 66H543.972C545.775 66.0062 547.502 66.7227 548.78 67.9941C550.059 69.2654 550.784 70.9893 550.8 72.792V398.508C550.8 400.321 550.081 402.06 548.801 403.345C547.522 404.629 545.785 405.354 543.972 405.36ZM312.252 66.24C310.515 66.2432 308.85 66.9345 307.622 68.1625C306.394 69.3906 305.703 71.0553 305.7 72.792V398.508C305.703 400.245 306.394 401.909 307.622 403.137C308.85 404.366 310.515 405.057 312.252 405.06H543.972C545.709 405.057 547.373 404.366 548.601 403.137C549.829 401.909 550.521 400.245 550.524 398.508V72.792C550.521 71.0553 549.829 69.3906 548.601 68.1625C547.373 66.9345 545.709 66.2432 543.972 66.24H312.252Z",
    fill: "#EBEBEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M534.864 458.858V399.59H529.8V371.354H522.396V273.17H511.68V260.51L488.82 249.842V237.074H485.652V273.17H481.224V371.354H476.784V319.73H464.748V293.126H461.388V371.354H452.256V341.582H446.232V333.986H432.3V308.018H424.668V289.646H415.284V262.874H411.936V289.646H402.552V308.018H394.932V333.986H380.988V341.582H374.976V371.354H367.836V333.986H353.904V253.538H349.464V244.67H319.692V253.538H313.356V311.81H288.024V317.51H278.52V321.95H288.024V344.75H261.42V268.742H255.72V252.59H243.372V195.266H239.88V252.59H231.012V268.742H179.028V263.426H175.86V299.522H171.42V300.158H168.756V336.266H164.328V346.082H154.956V319.478H151.596V382.826H147.852V356.222H144.492V397.706H142.452V367.934H136.44V360.338H122.496V334.37H114.864V315.998H105.492V289.238H102.144V315.998H92.7602V334.37H85.1282V360.338H71.1962V367.934H65.1722V397.082H64.0922V397.706H61.1162V458.858H534.864Z",
    fill: "#E6E6E6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M211.62 272.293H208.032V275.881H211.62V272.293Z",
    fill: "#F0F0F0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M211.62 278.305H208.032V281.893H211.62V278.305Z",
    fill: "#F0F0F0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M211.62 302.375H208.032V305.963H211.62V302.375Z",
    fill: "#F0F0F0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M211.62 308.398H208.032V311.986H211.62V308.398Z",
    fill: "#F0F0F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M211.62 314.41H208.032V317.998H211.62V314.41Z",
    fill: "#F0F0F0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M211.62 332.461H208.032V336.049H211.62V332.461Z",
    fill: "#F0F0F0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M211.62 338.484H208.032V342.072H211.62V338.484Z",
    fill: "#F0F0F0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M217.32 296.363H213.732V299.951H217.32V296.363Z",
    fill: "#F0F0F0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M217.32 302.375H213.732V305.963H217.32V302.375Z",
    fill: "#F0F0F0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M217.32 308.398H213.732V311.986H217.32V308.398Z",
    fill: "#F0F0F0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M217.32 314.41H213.732V317.998H217.32V314.41Z",
    fill: "#F0F0F0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M217.32 320.438H213.732V324.025H217.32V320.438Z",
    fill: "#F0F0F0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M217.32 332.461H213.732V336.049H217.32V332.461Z",
    fill: "#F0F0F0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M217.32 338.484H213.732V342.072H217.32V338.484Z",
    fill: "#F0F0F0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M223.02 272.293H219.432V275.881H223.02V272.293Z",
    fill: "#F0F0F0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M223.02 278.305H219.432V281.893H223.02V278.305Z",
    fill: "#F0F0F0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M223.02 284.328H219.432V287.916H223.02V284.328Z",
    fill: "#F0F0F0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M223.02 290.34H219.432V293.928H223.02V290.34Z",
    fill: "#F0F0F0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M223.02 296.363H219.432V299.951H223.02V296.363Z",
    fill: "#F0F0F0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M223.02 302.375H219.432V305.963H223.02V302.375Z",
    fill: "#F0F0F0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M223.02 308.398H219.432V311.986H223.02V308.398Z",
    fill: "#F0F0F0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M223.02 314.41H219.432V317.998H223.02V314.41Z",
    fill: "#F0F0F0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M223.02 320.438H219.432V324.025H223.02V320.438Z",
    fill: "#F0F0F0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M223.02 326.449H219.432V330.037H223.02V326.449Z",
    fill: "#F0F0F0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M223.02 338.484H219.432V342.072H223.02V338.484Z",
    fill: "#F0F0F0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M228.72 272.293H225.132V275.881H228.72V272.293Z",
    fill: "#F0F0F0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M228.72 278.305H225.132V281.893H228.72V278.305Z",
    fill: "#F0F0F0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M228.72 284.328H225.132V287.916H228.72V284.328Z",
    fill: "#F0F0F0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M228.72 290.34H225.132V293.928H228.72V290.34Z",
    fill: "#F0F0F0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M228.72 296.363H225.132V299.951H228.72V296.363Z",
    fill: "#F0F0F0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M228.72 302.375H225.132V305.963H228.72V302.375Z",
    fill: "#F0F0F0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M228.72 308.398H225.132V311.986H228.72V308.398Z",
    fill: "#F0F0F0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M228.72 362.555H225.132V366.143H228.72V362.555Z",
    fill: "#F0F0F0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M234.42 272.293H230.832V275.881H234.42V272.293Z",
    fill: "#F0F0F0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M234.42 278.305H230.832V281.893H234.42V278.305Z",
    fill: "#F0F0F0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M234.42 284.328H230.832V287.916H234.42V284.328Z",
    fill: "#F0F0F0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M234.42 290.34H230.832V293.928H234.42V290.34Z",
    fill: "#F0F0F0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M234.42 296.363H230.832V299.951H234.42V296.363Z",
    fill: "#F0F0F0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M234.42 302.375H230.832V305.963H234.42V302.375Z",
    fill: "#F0F0F0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M234.42 308.398H230.832V311.986H234.42V308.398Z",
    fill: "#F0F0F0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M234.42 314.41H230.832V317.998H234.42V314.41Z",
    fill: "#F0F0F0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M234.42 350.52H230.832V354.108H234.42V350.52Z",
    fill: "#F0F0F0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M234.42 356.531H230.832V360.119H234.42V356.531Z",
    fill: "#F0F0F0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M234.42 362.555H230.832V366.143H234.42V362.555Z",
    fill: "#F0F0F0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M234.42 368.566H230.832V372.154H234.42V368.566Z",
    fill: "#F0F0F0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M234.42 392.641H230.832V396.229H234.42V392.641Z",
    fill: "#F0F0F0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M240.12 272.293H236.532V275.881H240.12V272.293Z",
    fill: "#F0F0F0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M240.12 278.305H236.532V281.893H240.12V278.305Z",
    fill: "#F0F0F0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M240.12 284.328H236.532V287.916H240.12V284.328Z",
    fill: "#F0F0F0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M240.12 290.34H236.532V293.928H240.12V290.34Z",
    fill: "#F0F0F0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M240.12 296.363H236.532V299.951H240.12V296.363Z",
    fill: "#F0F0F0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M240.12 302.375H236.532V305.963H240.12V302.375Z",
    fill: "#F0F0F0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M240.12 308.398H236.532V311.986H240.12V308.398Z",
    fill: "#F0F0F0"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M240.12 314.41H236.532V317.998H240.12V314.41Z",
    fill: "#F0F0F0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M240.12 320.438H236.532V324.025H240.12V320.438Z",
    fill: "#F0F0F0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M240.12 326.449H236.532V330.037H240.12V326.449Z",
    fill: "#F0F0F0"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M240.12 344.496H236.532V348.084H240.12V344.496Z",
    fill: "#F0F0F0"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M240.12 350.52H236.532V354.108H240.12V350.52Z",
    fill: "#F0F0F0"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M240.12 356.531H236.532V360.119H240.12V356.531Z",
    fill: "#F0F0F0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M240.12 362.555H236.532V366.143H240.12V362.555Z",
    fill: "#F0F0F0"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M240.12 368.566H236.532V372.154H240.12V368.566Z",
    fill: "#F0F0F0"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M240.12 392.641H236.532V396.229H240.12V392.641Z",
    fill: "#F0F0F0"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M245.82 272.293H242.232V275.881H245.82V272.293Z",
    fill: "#F0F0F0"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M245.82 278.305H242.232V281.893H245.82V278.305Z",
    fill: "#F0F0F0"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M245.82 284.328H242.232V287.916H245.82V284.328Z",
    fill: "#F0F0F0"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M245.82 290.34H242.232V293.928H245.82V290.34Z",
    fill: "#F0F0F0"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M245.82 296.363H242.232V299.951H245.82V296.363Z",
    fill: "#F0F0F0"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M245.82 302.375H242.232V305.963H245.82V302.375Z",
    fill: "#F0F0F0"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M245.82 308.398H242.232V311.986H245.82V308.398Z",
    fill: "#F0F0F0"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M245.82 314.41H242.232V317.998H245.82V314.41Z",
    fill: "#F0F0F0"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M245.82 320.438H242.232V324.025H245.82V320.438Z",
    fill: "#F0F0F0"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M245.82 326.449H242.232V330.037H245.82V326.449Z",
    fill: "#F0F0F0"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M245.82 332.461H242.232V336.049H245.82V332.461Z",
    fill: "#F0F0F0"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M245.82 338.484H242.232V342.072H245.82V338.484Z",
    fill: "#F0F0F0"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M245.82 344.496H242.232V348.084H245.82V344.496Z",
    fill: "#F0F0F0"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M245.82 350.52H242.232V354.108H245.82V350.52Z",
    fill: "#F0F0F0"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M245.82 356.531H242.232V360.119H245.82V356.531Z",
    fill: "#F0F0F0"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M245.82 362.555H242.232V366.143H245.82V362.555Z",
    fill: "#F0F0F0"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M245.82 368.566H242.232V372.154H245.82V368.566Z",
    fill: "#F0F0F0"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M245.82 374.594H242.232V378.182H245.82V374.594Z",
    fill: "#F0F0F0"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M251.532 272.293H247.944V275.881H251.532V272.293Z",
    fill: "#F0F0F0"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M251.532 278.305H247.944V281.893H251.532V278.305Z",
    fill: "#F0F0F0"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M251.532 284.328H247.944V287.916H251.532V284.328Z",
    fill: "#F0F0F0"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M251.532 290.34H247.944V293.928H251.532V290.34Z",
    fill: "#F0F0F0"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M251.532 296.363H247.944V299.951H251.532V296.363Z",
    fill: "#F0F0F0"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M251.532 302.375H247.944V305.963H251.532V302.375Z",
    fill: "#F0F0F0"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M251.532 308.398H247.944V311.986H251.532V308.398Z",
    fill: "#F0F0F0"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M251.532 314.41H247.944V317.998H251.532V314.41Z",
    fill: "#F0F0F0"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M251.532 320.438H247.944V324.025H251.532V320.438Z",
    fill: "#F0F0F0"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M251.532 326.449H247.944V330.037H251.532V326.449Z",
    fill: "#F0F0F0"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M251.532 344.496H247.944V348.084H251.532V344.496Z",
    fill: "#F0F0F0"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M251.532 350.52H247.944V354.108H251.532V350.52Z",
    fill: "#F0F0F0"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M251.532 356.531H247.944V360.119H251.532V356.531Z",
    fill: "#F0F0F0"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M251.532 362.555H247.944V366.143H251.532V362.555Z",
    fill: "#F0F0F0"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M257.232 272.293H253.644V275.881H257.232V272.293Z",
    fill: "#F0F0F0"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M257.232 278.305H253.644V281.893H257.232V278.305Z",
    fill: "#F0F0F0"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M257.232 284.328H253.644V287.916H257.232V284.328Z",
    fill: "#F0F0F0"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M257.232 290.34H253.644V293.928H257.232V290.34Z",
    fill: "#F0F0F0"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M257.232 296.363H253.644V299.951H257.232V296.363Z",
    fill: "#F0F0F0"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M257.232 302.375H253.644V305.963H257.232V302.375Z",
    fill: "#F0F0F0"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M257.232 308.398H253.644V311.986H257.232V308.398Z",
    fill: "#F0F0F0"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M257.232 314.41H253.644V317.998H257.232V314.41Z",
    fill: "#F0F0F0"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M257.232 320.438H253.644V324.025H257.232V320.438Z",
    fill: "#F0F0F0"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M257.232 326.449H253.644V330.037H257.232V326.449Z",
    fill: "#F0F0F0"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M257.232 344.496H253.644V348.084H257.232V344.496Z",
    fill: "#F0F0F0"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M257.232 350.52H253.644V354.108H257.232V350.52Z",
    fill: "#F0F0F0"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M257.232 356.531H253.644V360.119H257.232V356.531Z",
    fill: "#F0F0F0"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M321.42 256.668H317.832V260.256H321.42V256.668Z",
    fill: "#F0F0F0"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M321.42 262.68H317.832V266.268H321.42V262.68Z",
    fill: "#F0F0F0"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M321.42 268.703H317.832V272.291H321.42V268.703Z",
    fill: "#F0F0F0"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M321.42 274.715H317.832V278.303H321.42V274.715Z",
    fill: "#F0F0F0"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M321.42 280.738H317.832V284.326H321.42V280.738Z",
    fill: "#F0F0F0"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M321.42 286.754H317.832V290.342H321.42V286.754Z",
    fill: "#F0F0F0"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M321.42 292.777H317.832V296.365H321.42V292.777Z",
    fill: "#F0F0F0"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M321.42 298.789H317.832V302.377H321.42V298.789Z",
    fill: "#F0F0F0"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M321.42 316.836H317.832V320.424H321.42V316.836Z",
    fill: "#F0F0F0"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M321.42 322.859H317.832V326.447H321.42V322.859Z",
    fill: "#F0F0F0"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M327.12 256.668H323.532V260.256H327.12V256.668Z",
    fill: "#F0F0F0"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M327.12 262.68H323.532V266.268H327.12V262.68Z",
    fill: "#F0F0F0"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M327.12 268.703H323.532V272.291H327.12V268.703Z",
    fill: "#F0F0F0"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M327.12 274.715H323.532V278.303H327.12V274.715Z",
    fill: "#F0F0F0"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M327.12 280.738H323.532V284.326H327.12V280.738Z",
    fill: "#F0F0F0"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M327.12 286.754H323.532V290.342H327.12V286.754Z",
    fill: "#F0F0F0"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M327.12 292.777H323.532V296.365H327.12V292.777Z",
    fill: "#F0F0F0"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M327.12 298.789H323.532V302.377H327.12V298.789Z",
    fill: "#F0F0F0"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M327.12 322.859H323.532V326.447H327.12V322.859Z",
    fill: "#F0F0F0"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M332.82 256.668H329.232V260.256H332.82V256.668Z",
    fill: "#F0F0F0"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M332.82 262.68H329.232V266.268H332.82V262.68Z",
    fill: "#F0F0F0"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M332.82 268.703H329.232V272.291H332.82V268.703Z",
    fill: "#F0F0F0"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M332.82 274.715H329.232V278.303H332.82V274.715Z",
    fill: "#F0F0F0"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M332.82 280.738H329.232V284.326H332.82V280.738Z",
    fill: "#F0F0F0"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M332.82 286.754H329.232V290.342H332.82V286.754Z",
    fill: "#F0F0F0"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M332.82 292.777H329.232V296.365H332.82V292.777Z",
    fill: "#F0F0F0"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M332.82 298.789H329.232V302.377H332.82V298.789Z",
    fill: "#F0F0F0"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M338.52 256.668H334.932V260.256H338.52V256.668Z",
    fill: "#F0F0F0"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M338.52 262.68H334.932V266.268H338.52V262.68Z",
    fill: "#F0F0F0"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M338.52 268.703H334.932V272.291H338.52V268.703Z",
    fill: "#F0F0F0"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M338.52 274.715H334.932V278.303H338.52V274.715Z",
    fill: "#F0F0F0"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M338.52 280.738H334.932V284.326H338.52V280.738Z",
    fill: "#F0F0F0"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M338.52 286.754H334.932V290.342H338.52V286.754Z",
    fill: "#F0F0F0"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M338.52 298.789H334.932V302.377H338.52V298.789Z",
    fill: "#F0F0F0"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M338.52 304.801H334.932V308.389H338.52V304.801Z",
    fill: "#F0F0F0"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M338.52 322.859H334.932V326.447H338.52V322.859Z",
    fill: "#F0F0F0"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M338.52 328.871H334.932V332.459H338.52V328.871Z",
    fill: "#F0F0F0"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M338.52 334.895H334.932V338.483H338.52V334.895Z",
    fill: "#F0F0F0"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M338.52 340.906H334.932V344.494H338.52V340.906Z",
    fill: "#F0F0F0"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M338.52 346.934H334.932V350.522H338.52V346.934Z",
    fill: "#F0F0F0"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M338.52 352.945H334.932V356.533H338.52V352.945Z",
    fill: "#F0F0F0"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M338.52 358.969H334.932V362.557H338.52V358.969Z",
    fill: "#F0F0F0"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M344.22 256.668H340.632V260.256H344.22V256.668Z",
    fill: "#F0F0F0"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M344.22 262.68H340.632V266.268H344.22V262.68Z",
    fill: "#F0F0F0"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M344.22 268.703H340.632V272.291H344.22V268.703Z",
    fill: "#F0F0F0"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M344.22 274.715H340.632V278.303H344.22V274.715Z",
    fill: "#F0F0F0"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M344.22 280.738H340.632V284.326H344.22V280.738Z",
    fill: "#F0F0F0"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M344.22 286.754H340.632V290.342H344.22V286.754Z",
    fill: "#F0F0F0"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M344.22 304.801H340.632V308.389H344.22V304.801Z",
    fill: "#F0F0F0"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M344.22 310.824H340.632V314.412H344.22V310.824Z",
    fill: "#F0F0F0"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M344.22 316.836H340.632V320.424H344.22V316.836Z",
    fill: "#F0F0F0"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M344.22 322.859H340.632V326.447H344.22V322.859Z",
    fill: "#F0F0F0"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M344.22 328.871H340.632V332.459H344.22V328.871Z",
    fill: "#F0F0F0"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M344.22 334.895H340.632V338.483H344.22V334.895Z",
    fill: "#F0F0F0"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M344.22 340.906H340.632V344.494H344.22V340.906Z",
    fill: "#F0F0F0"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M344.22 346.934H340.632V350.522H344.22V346.934Z",
    fill: "#F0F0F0"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M344.22 352.945H340.632V356.533H344.22V352.945Z",
    fill: "#F0F0F0"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M344.22 358.969H340.632V362.557H344.22V358.969Z",
    fill: "#F0F0F0"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M344.22 364.98H340.632V368.568H344.22V364.98Z",
    fill: "#F0F0F0"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M344.22 377.016H340.632V380.604H344.22V377.016Z",
    fill: "#F0F0F0"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M349.92 256.668H346.332V260.256H349.92V256.668Z",
    fill: "#F0F0F0"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M349.92 262.68H346.332V266.268H349.92V262.68Z",
    fill: "#F0F0F0"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M349.92 268.703H346.332V272.291H349.92V268.703Z",
    fill: "#F0F0F0"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M349.92 274.715H346.332V278.303H349.92V274.715Z",
    fill: "#F0F0F0"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M349.92 280.738H346.332V284.326H349.92V280.738Z",
    fill: "#F0F0F0"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M349.92 286.754H346.332V290.342H349.92V286.754Z",
    fill: "#F0F0F0"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M349.92 304.801H346.332V308.389H349.92V304.801Z",
    fill: "#F0F0F0"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M349.92 310.824H346.332V314.412H349.92V310.824Z",
    fill: "#F0F0F0"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M349.92 316.836H346.332V320.424H349.92V316.836Z",
    fill: "#F0F0F0"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M349.92 322.859H346.332V326.447H349.92V322.859Z",
    fill: "#F0F0F0"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M349.92 340.906H346.332V344.494H349.92V340.906Z",
    fill: "#F0F0F0"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M349.92 346.934H346.332V350.522H349.92V346.934Z",
    fill: "#F0F0F0"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M349.92 352.945H346.332V356.533H349.92V352.945Z",
    fill: "#F0F0F0"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M349.92 358.969H346.332V362.557H349.92V358.969Z",
    fill: "#F0F0F0"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M349.92 364.98H346.332V368.568H349.92V364.98Z",
    fill: "#F0F0F0"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M349.92 377.016H346.332V380.604H349.92V377.016Z",
    fill: "#F0F0F0"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M349.92 383.039H346.332V386.627H349.92V383.039Z",
    fill: "#F0F0F0"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M401.652 312.613H398.064V316.201H401.652V312.613Z",
    fill: "#F0F0F0"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M401.652 318.637H398.064V322.225H401.652V318.637Z",
    fill: "#F0F0F0"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M401.652 324.648H398.064V328.236H401.652V324.648Z",
    fill: "#F0F0F0"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M401.652 330.672H398.064V334.26H401.652V330.672Z",
    fill: "#F0F0F0"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M401.652 336.684H398.064V340.272H401.652V336.684Z",
    fill: "#F0F0F0"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M401.652 342.707H398.064V346.295H401.652V342.707Z",
    fill: "#F0F0F0"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M401.652 348.719H398.064V352.307H401.652V348.719Z",
    fill: "#F0F0F0"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M401.652 366.781H398.064V370.369H401.652V366.781Z",
    fill: "#F0F0F0"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M401.652 372.793H398.064V376.381H401.652V372.793Z",
    fill: "#F0F0F0"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M401.652 378.816H398.064V382.404H401.652V378.816Z",
    fill: "#F0F0F0"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M407.352 312.613H403.764V316.201H407.352V312.613Z",
    fill: "#F0F0F0"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M407.352 318.637H403.764V322.225H407.352V318.637Z",
    fill: "#F0F0F0"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M407.352 324.648H403.764V328.236H407.352V324.648Z",
    fill: "#F0F0F0"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M407.352 330.672H403.764V334.26H407.352V330.672Z",
    fill: "#F0F0F0"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M407.352 336.684H403.764V340.272H407.352V336.684Z",
    fill: "#F0F0F0"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M407.352 342.707H403.764V346.295H407.352V342.707Z",
    fill: "#F0F0F0"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M407.352 348.719H403.764V352.307H407.352V348.719Z",
    fill: "#F0F0F0"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M413.052 312.613H409.464V316.201H413.052V312.613Z",
    fill: "#F0F0F0"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M413.052 318.637H409.464V322.225H413.052V318.637Z",
    fill: "#F0F0F0"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M413.052 324.648H409.464V328.236H413.052V324.648Z",
    fill: "#F0F0F0"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M413.052 330.672H409.464V334.26H413.052V330.672Z",
    fill: "#F0F0F0"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M413.052 336.684H409.464V340.272H413.052V336.684Z",
    fill: "#F0F0F0"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M413.052 342.707H409.464V346.295H413.052V342.707Z",
    fill: "#F0F0F0"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M413.052 348.719H409.464V352.307H413.052V348.719Z",
    fill: "#F0F0F0"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M418.752 312.613H415.164V316.201H418.752V312.613Z",
    fill: "#F0F0F0"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M418.752 318.637H415.164V322.225H418.752V318.637Z",
    fill: "#F0F0F0"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M418.752 324.648H415.164V328.236H418.752V324.648Z",
    fill: "#F0F0F0"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M418.752 330.672H415.164V334.26H418.752V330.672Z",
    fill: "#F0F0F0"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M418.752 336.684H415.164V340.272H418.752V336.684Z",
    fill: "#F0F0F0"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M418.752 342.707H415.164V346.295H418.752V342.707Z",
    fill: "#F0F0F0"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M418.752 348.719H415.164V352.307H418.752V348.719Z",
    fill: "#F0F0F0"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M418.752 354.742H415.164V358.33H418.752V354.742Z",
    fill: "#F0F0F0"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M418.752 360.758H415.164V364.346H418.752V360.758Z",
    fill: "#F0F0F0"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M418.752 366.781H415.164V370.369H418.752V366.781Z",
    fill: "#F0F0F0"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M418.752 372.793H415.164V376.381H418.752V372.793Z",
    fill: "#F0F0F0"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M424.452 312.613H420.864V316.201H424.452V312.613Z",
    fill: "#F0F0F0"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M424.452 318.637H420.864V322.225H424.452V318.637Z",
    fill: "#F0F0F0"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M424.452 324.648H420.864V328.236H424.452V324.648Z",
    fill: "#F0F0F0"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M424.452 330.672H420.864V334.26H424.452V330.672Z",
    fill: "#F0F0F0"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M424.452 336.684H420.864V340.272H424.452V336.684Z",
    fill: "#F0F0F0"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M424.452 342.707H420.864V346.295H424.452V342.707Z",
    fill: "#F0F0F0"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M424.452 348.719H420.864V352.307H424.452V348.719Z",
    fill: "#F0F0F0"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M424.452 354.742H420.864V358.33H424.452V354.742Z",
    fill: "#F0F0F0"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M424.452 360.758H420.864V364.346H424.452V360.758Z",
    fill: "#F0F0F0"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M424.452 366.781H420.864V370.369H424.452V366.781Z",
    fill: "#F0F0F0"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M424.452 372.793H420.864V376.381H424.452V372.793Z",
    fill: "#F0F0F0"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M424.452 378.816H420.864V382.404H424.452V378.816Z",
    fill: "#F0F0F0"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M424.452 396.863H420.864V400.451H424.452V396.863Z",
    fill: "#F0F0F0"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M424.452 402.887H420.864V406.475H424.452V402.887Z",
    fill: "#F0F0F0"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M430.152 312.613H426.564V316.201H430.152V312.613Z",
    fill: "#F0F0F0"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M430.152 318.637H426.564V322.225H430.152V318.637Z",
    fill: "#F0F0F0"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M430.152 324.648H426.564V328.236H430.152V324.648Z",
    fill: "#F0F0F0"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M430.152 342.707H426.564V346.295H430.152V342.707Z",
    fill: "#F0F0F0"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M430.152 348.719H426.564V352.307H430.152V348.719Z",
    fill: "#F0F0F0"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M430.152 354.742H426.564V358.33H430.152V354.742Z",
    fill: "#F0F0F0"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M430.152 360.758H426.564V364.346H430.152V360.758Z",
    fill: "#F0F0F0"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M430.152 366.781H426.564V370.369H430.152V366.781Z",
    fill: "#F0F0F0"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M430.152 372.793H426.564V376.381H430.152V372.793Z",
    fill: "#F0F0F0"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M430.152 378.816H426.564V382.404H430.152V378.816Z",
    fill: "#F0F0F0"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M430.152 396.863H426.564V400.451H430.152V396.863Z",
    fill: "#F0F0F0"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M430.152 402.887H426.564V406.475H430.152V402.887Z",
    fill: "#F0F0F0"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M430.152 408.898H426.564V412.486H430.152V408.898Z",
    fill: "#F0F0F0"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M489.912 276.516H486.324V280.104H489.912V276.516Z",
    fill: "#F0F0F0"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M489.912 282.527H486.324V286.115H489.912V282.527Z",
    fill: "#F0F0F0"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M489.912 288.551H486.324V292.139H489.912V288.551Z",
    fill: "#F0F0F0"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M489.912 294.562H486.324V298.151H489.912V294.562Z",
    fill: "#F0F0F0"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M489.912 300.59H486.324V304.178H489.912V300.59Z",
    fill: "#F0F0F0"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M489.912 306.602H486.324V310.19H489.912V306.602Z",
    fill: "#F0F0F0"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M489.912 312.613H486.324V316.201H489.912V312.613Z",
    fill: "#F0F0F0"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M489.912 318.637H486.324V322.225H489.912V318.637Z",
    fill: "#F0F0F0"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M489.912 324.648H486.324V328.236H489.912V324.648Z",
    fill: "#F0F0F0"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M489.912 330.672H486.324V334.26H489.912V330.672Z",
    fill: "#F0F0F0"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M489.912 336.684H486.324V340.272H489.912V336.684Z",
    fill: "#F0F0F0"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M489.912 342.707H486.324V346.295H489.912V342.707Z",
    fill: "#F0F0F0"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M489.912 348.719H486.324V352.307H489.912V348.719Z",
    fill: "#F0F0F0"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M489.912 354.742H486.324V358.33H489.912V354.742Z",
    fill: "#F0F0F0"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M489.912 360.758H486.324V364.346H489.912V360.758Z",
    fill: "#F0F0F0"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M489.912 366.781H486.324V370.369H489.912V366.781Z",
    fill: "#F0F0F0"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M489.912 372.793H486.324V376.381H489.912V372.793Z",
    fill: "#F0F0F0"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M489.912 378.816H486.324V382.404H489.912V378.816Z",
    fill: "#F0F0F0"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M489.912 384.828H486.324V388.416H489.912V384.828Z",
    fill: "#F0F0F0"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M489.912 390.852H486.324V394.44H489.912V390.852Z",
    fill: "#F0F0F0"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M489.912 396.863H486.324V400.451H489.912V396.863Z",
    fill: "#F0F0F0"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M489.912 402.887H486.324V406.475H489.912V402.887Z",
    fill: "#F0F0F0"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M489.912 408.898H486.324V412.486H489.912V408.898Z",
    fill: "#F0F0F0"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M495.612 276.516H492.024V280.104H495.612V276.516Z",
    fill: "#F0F0F0"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M495.612 282.527H492.024V286.115H495.612V282.527Z",
    fill: "#F0F0F0"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M495.612 288.551H492.024V292.139H495.612V288.551Z",
    fill: "#F0F0F0"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M495.612 294.562H492.024V298.151H495.612V294.562Z",
    fill: "#F0F0F0"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M495.612 300.59H492.024V304.178H495.612V300.59Z",
    fill: "#F0F0F0"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M495.612 306.602H492.024V310.19H495.612V306.602Z",
    fill: "#F0F0F0"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M495.612 312.613H492.024V316.201H495.612V312.613Z",
    fill: "#F0F0F0"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M495.612 318.637H492.024V322.225H495.612V318.637Z",
    fill: "#F0F0F0"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M495.612 324.648H492.024V328.236H495.612V324.648Z",
    fill: "#F0F0F0"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M495.612 330.672H492.024V334.26H495.612V330.672Z",
    fill: "#F0F0F0"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M495.612 336.684H492.024V340.272H495.612V336.684Z",
    fill: "#F0F0F0"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M495.612 342.707H492.024V346.295H495.612V342.707Z",
    fill: "#F0F0F0"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M495.612 348.719H492.024V352.307H495.612V348.719Z",
    fill: "#F0F0F0"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M495.612 354.742H492.024V358.33H495.612V354.742Z",
    fill: "#F0F0F0"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M495.612 360.758H492.024V364.346H495.612V360.758Z",
    fill: "#F0F0F0"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M495.612 366.781H492.024V370.369H495.612V366.781Z",
    fill: "#F0F0F0"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M495.612 372.793H492.024V376.381H495.612V372.793Z",
    fill: "#F0F0F0"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M495.612 378.816H492.024V382.404H495.612V378.816Z",
    fill: "#F0F0F0"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M495.612 384.828H492.024V388.416H495.612V384.828Z",
    fill: "#F0F0F0"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M501.312 276.516H497.724V280.104H501.312V276.516Z",
    fill: "#F0F0F0"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M501.312 282.527H497.724V286.115H501.312V282.527Z",
    fill: "#F0F0F0"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M501.312 288.551H497.724V292.139H501.312V288.551Z",
    fill: "#F0F0F0"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M501.312 294.562H497.724V298.151H501.312V294.562Z",
    fill: "#F0F0F0"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M501.312 300.59H497.724V304.178H501.312V300.59Z",
    fill: "#F0F0F0"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M501.312 306.602H497.724V310.19H501.312V306.602Z",
    fill: "#F0F0F0"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M501.312 312.613H497.724V316.201H501.312V312.613Z",
    fill: "#F0F0F0"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M501.312 318.637H497.724V322.225H501.312V318.637Z",
    fill: "#F0F0F0"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M501.312 324.648H497.724V328.236H501.312V324.648Z",
    fill: "#F0F0F0"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M501.312 330.672H497.724V334.26H501.312V330.672Z",
    fill: "#F0F0F0"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M501.312 336.684H497.724V340.272H501.312V336.684Z",
    fill: "#F0F0F0"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M501.312 342.707H497.724V346.295H501.312V342.707Z",
    fill: "#F0F0F0"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M501.312 348.719H497.724V352.307H501.312V348.719Z",
    fill: "#F0F0F0"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M501.312 354.742H497.724V358.33H501.312V354.742Z",
    fill: "#F0F0F0"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M501.312 360.758H497.724V364.346H501.312V360.758Z",
    fill: "#F0F0F0"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M501.312 366.781H497.724V370.369H501.312V366.781Z",
    fill: "#F0F0F0"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M501.312 372.793H497.724V376.381H501.312V372.793Z",
    fill: "#F0F0F0"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M501.312 378.816H497.724V382.404H501.312V378.816Z",
    fill: "#F0F0F0"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M501.312 384.828H497.724V388.416H501.312V384.828Z",
    fill: "#F0F0F0"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M507.012 276.516H503.424V280.104H507.012V276.516Z",
    fill: "#F0F0F0"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M507.012 282.527H503.424V286.115H507.012V282.527Z",
    fill: "#F0F0F0"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M507.012 288.551H503.424V292.139H507.012V288.551Z",
    fill: "#F0F0F0"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M507.012 294.562H503.424V298.151H507.012V294.562Z",
    fill: "#F0F0F0"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M507.012 300.59H503.424V304.178H507.012V300.59Z",
    fill: "#F0F0F0"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M507.012 306.602H503.424V310.19H507.012V306.602Z",
    fill: "#F0F0F0"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M507.012 312.613H503.424V316.201H507.012V312.613Z",
    fill: "#F0F0F0"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M507.012 318.637H503.424V322.225H507.012V318.637Z",
    fill: "#F0F0F0"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M507.012 324.648H503.424V328.236H507.012V324.648Z",
    fill: "#F0F0F0"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M507.012 330.672H503.424V334.26H507.012V330.672Z",
    fill: "#F0F0F0"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M507.012 336.684H503.424V340.272H507.012V336.684Z",
    fill: "#F0F0F0"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M507.012 342.707H503.424V346.295H507.012V342.707Z",
    fill: "#F0F0F0"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M507.012 348.719H503.424V352.307H507.012V348.719Z",
    fill: "#F0F0F0"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M507.012 354.742H503.424V358.33H507.012V354.742Z",
    fill: "#F0F0F0"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M507.012 360.758H503.424V364.346H507.012V360.758Z",
    fill: "#F0F0F0"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M512.712 276.516H509.124V280.104H512.712V276.516Z",
    fill: "#F0F0F0"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M512.712 282.527H509.124V286.115H512.712V282.527Z",
    fill: "#F0F0F0"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M512.712 288.551H509.124V292.139H512.712V288.551Z",
    fill: "#F0F0F0"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M512.712 294.562H509.124V298.151H512.712V294.562Z",
    fill: "#F0F0F0"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M512.712 300.59H509.124V304.178H512.712V300.59Z",
    fill: "#F0F0F0"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M512.712 306.602H509.124V310.19H512.712V306.602Z",
    fill: "#F0F0F0"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M512.712 312.613H509.124V316.201H512.712V312.613Z",
    fill: "#F0F0F0"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M512.712 318.637H509.124V322.225H512.712V318.637Z",
    fill: "#F0F0F0"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M512.712 324.648H509.124V328.236H512.712V324.648Z",
    fill: "#F0F0F0"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M512.712 330.672H509.124V334.26H512.712V330.672Z",
    fill: "#F0F0F0"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M512.712 336.684H509.124V340.272H512.712V336.684Z",
    fill: "#F0F0F0"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M512.712 342.707H509.124V346.295H512.712V342.707Z",
    fill: "#F0F0F0"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M512.712 348.719H509.124V352.307H512.712V348.719Z",
    fill: "#F0F0F0"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M518.412 276.516H514.824V280.104H518.412V276.516Z",
    fill: "#F0F0F0"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M518.412 282.527H514.824V286.115H518.412V282.527Z",
    fill: "#F0F0F0"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M518.412 288.551H514.824V292.139H518.412V288.551Z",
    fill: "#F0F0F0"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M518.412 294.562H514.824V298.151H518.412V294.562Z",
    fill: "#F0F0F0"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M518.412 300.59H514.824V304.178H518.412V300.59Z",
    fill: "#F0F0F0"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M518.412 306.602H514.824V310.19H518.412V306.602Z",
    fill: "#F0F0F0"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M518.412 312.613H514.824V316.201H518.412V312.613Z",
    fill: "#F0F0F0"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M518.412 318.637H514.824V322.225H518.412V318.637Z",
    fill: "#F0F0F0"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M518.412 324.648H514.824V328.236H518.412V324.648Z",
    fill: "#F0F0F0"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M518.412 330.672H514.824V334.26H518.412V330.672Z",
    fill: "#F0F0F0"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M518.412 336.684H514.824V340.272H518.412V336.684Z",
    fill: "#F0F0F0"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M518.412 342.707H514.824V346.295H518.412V342.707Z",
    fill: "#F0F0F0"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M99.504 320.438H95.916V324.025H99.504V320.438Z",
    fill: "#F0F0F0"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M99.504 326.449H95.916V330.037H99.504V326.449Z",
    fill: "#F0F0F0"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M99.504 332.461H95.916V336.049H99.504V332.461Z",
    fill: "#F0F0F0"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M99.504 338.484H95.916V342.072H99.504V338.484Z",
    fill: "#F0F0F0"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M99.504 344.496H95.916V348.084H99.504V344.496Z",
    fill: "#F0F0F0"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M99.504 350.52H95.916V354.108H99.504V350.52Z",
    fill: "#F0F0F0"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M99.504 356.531H95.916V360.119H99.504V356.531Z",
    fill: "#F0F0F0"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M99.504 362.555H95.916V366.143H99.504V362.555Z",
    fill: "#F0F0F0"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M99.504 368.566H95.916V372.154H99.504V368.566Z",
    fill: "#F0F0F0"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M99.504 374.594H95.916V378.182H99.504V374.594Z",
    fill: "#F0F0F0"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M99.504 380.605H95.916V384.193H99.504V380.605Z",
    fill: "#F0F0F0"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M99.504 386.629H95.916V390.217H99.504V386.629Z",
    fill: "#F0F0F0"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M99.504 392.641H95.916V396.229H99.504V392.641Z",
    fill: "#F0F0F0"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M99.504 398.664H95.916V402.252H99.504V398.664Z",
    fill: "#F0F0F0"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M99.504 404.676H95.916V408.264H99.504V404.676Z",
    fill: "#F0F0F0"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M99.504 410.699H95.916V414.287H99.504V410.699Z",
    fill: "#F0F0F0"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M99.504 416.711H95.916V420.299H99.504V416.711Z",
    fill: "#F0F0F0"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M99.504 422.723H95.916V426.311H99.504V422.723Z",
    fill: "#F0F0F0"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M99.504 428.746H95.916V432.334H99.504V428.746Z",
    fill: "#F0F0F0"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M99.504 434.762H95.916V438.35H99.504V434.762Z",
    fill: "#F0F0F0"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M105.204 320.438H101.616V324.025H105.204V320.438Z",
    fill: "#F0F0F0"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M105.204 326.449H101.616V330.037H105.204V326.449Z",
    fill: "#F0F0F0"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M105.204 332.461H101.616V336.049H105.204V332.461Z",
    fill: "#F0F0F0"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M105.204 338.484H101.616V342.072H105.204V338.484Z",
    fill: "#F0F0F0"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M105.204 344.496H101.616V348.084H105.204V344.496Z",
    fill: "#F0F0F0"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M105.204 350.52H101.616V354.108H105.204V350.52Z",
    fill: "#F0F0F0"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M105.204 356.531H101.616V360.119H105.204V356.531Z",
    fill: "#F0F0F0"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M105.204 362.555H101.616V366.143H105.204V362.555Z",
    fill: "#F0F0F0"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M105.204 368.566H101.616V372.154H105.204V368.566Z",
    fill: "#F0F0F0"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M105.204 374.594H101.616V378.182H105.204V374.594Z",
    fill: "#F0F0F0"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M105.204 380.605H101.616V384.193H105.204V380.605Z",
    fill: "#F0F0F0"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M105.204 386.629H101.616V390.217H105.204V386.629Z",
    fill: "#F0F0F0"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M105.204 392.641H101.616V396.229H105.204V392.641Z",
    fill: "#F0F0F0"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M105.204 398.664H101.616V402.252H105.204V398.664Z",
    fill: "#F0F0F0"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M105.204 404.676H101.616V408.264H105.204V404.676Z",
    fill: "#F0F0F0"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M105.204 410.699H101.616V414.287H105.204V410.699Z",
    fill: "#F0F0F0"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M105.204 416.711H101.616V420.299H105.204V416.711Z",
    fill: "#F0F0F0"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M105.204 422.723H101.616V426.311H105.204V422.723Z",
    fill: "#F0F0F0"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M110.904 320.438H107.316V324.025H110.904V320.438Z",
    fill: "#F0F0F0"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M110.904 326.449H107.316V330.037H110.904V326.449Z",
    fill: "#F0F0F0"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M110.904 332.461H107.316V336.049H110.904V332.461Z",
    fill: "#F0F0F0"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M110.904 338.484H107.316V342.072H110.904V338.484Z",
    fill: "#F0F0F0"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M110.904 344.496H107.316V348.084H110.904V344.496Z",
    fill: "#F0F0F0"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M110.904 350.52H107.316V354.108H110.904V350.52Z",
    fill: "#F0F0F0"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M110.904 356.531H107.316V360.119H110.904V356.531Z",
    fill: "#F0F0F0"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M110.904 362.555H107.316V366.143H110.904V362.555Z",
    fill: "#F0F0F0"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M110.904 368.566H107.316V372.154H110.904V368.566Z",
    fill: "#F0F0F0"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M110.904 374.594H107.316V378.182H110.904V374.594Z",
    fill: "#F0F0F0"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M110.904 380.605H107.316V384.193H110.904V380.605Z",
    fill: "#F0F0F0"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M110.904 386.629H107.316V390.217H110.904V386.629Z",
    fill: "#F0F0F0"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M110.904 392.641H107.316V396.229H110.904V392.641Z",
    fill: "#F0F0F0"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M110.904 398.664H107.316V402.252H110.904V398.664Z",
    fill: "#F0F0F0"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M110.904 404.676H107.316V408.264H110.904V404.676Z",
    fill: "#F0F0F0"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M110.904 410.699H107.316V414.287H110.904V410.699Z",
    fill: "#F0F0F0"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M110.904 416.711H107.316V420.299H110.904V416.711Z",
    fill: "#F0F0F0"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M110.904 422.723H107.316V426.311H110.904V422.723Z",
    fill: "#F0F0F0"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1798 364.344H74.5918V367.932H78.1798V364.344Z",
    fill: "#F0F0F0"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1798 370.367H74.5918V373.955H78.1798V370.367Z",
    fill: "#F0F0F0"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1798 376.379H74.5918V379.967H78.1798V376.379Z",
    fill: "#F0F0F0"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1798 382.402H74.5918V385.99H78.1798V382.402Z",
    fill: "#F0F0F0"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1798 388.414H74.5918V392.002H78.1798V388.414Z",
    fill: "#F0F0F0"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1798 394.441H74.5918V398.029H78.1798V394.441Z",
    fill: "#F0F0F0"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1798 400.453H74.5918V404.041H78.1798V400.453Z",
    fill: "#F0F0F0"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1798 406.477H74.5918V410.065H78.1798V406.477Z",
    fill: "#F0F0F0"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1798 412.488H74.5918V416.076H78.1798V412.488Z",
    fill: "#F0F0F0"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1798 418.512H74.5918V422.1H78.1798V418.512Z",
    fill: "#F0F0F0"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1798 424.523H74.5918V428.111H78.1798V424.523Z",
    fill: "#F0F0F0"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1798 430.547H74.5918V434.135H78.1798V430.547Z",
    fill: "#F0F0F0"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1798 436.559H74.5918V440.147H78.1798V436.559Z",
    fill: "#F0F0F0"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M83.88 364.344H80.292V367.932H83.88V364.344Z",
    fill: "#F0F0F0"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M83.88 370.367H80.292V373.955H83.88V370.367Z",
    fill: "#F0F0F0"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M83.88 376.379H80.292V379.967H83.88V376.379Z",
    fill: "#F0F0F0"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M83.88 382.402H80.292V385.99H83.88V382.402Z",
    fill: "#F0F0F0"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M83.88 388.414H80.292V392.002H83.88V388.414Z",
    fill: "#F0F0F0"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M83.88 394.441H80.292V398.029H83.88V394.441Z",
    fill: "#F0F0F0"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M83.88 400.453H80.292V404.041H83.88V400.453Z",
    fill: "#F0F0F0"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M83.88 406.477H80.292V410.065H83.88V406.477Z",
    fill: "#F0F0F0"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M83.88 412.488H80.292V416.076H83.88V412.488Z",
    fill: "#F0F0F0"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M83.88 418.512H80.292V422.1H83.88V418.512Z",
    fill: "#F0F0F0"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M83.88 424.523H80.292V428.111H83.88V424.523Z",
    fill: "#F0F0F0"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M83.88 430.547H80.292V434.135H83.88V430.547Z",
    fill: "#F0F0F0"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M83.88 436.559H80.292V440.147H83.88V436.559Z",
    fill: "#F0F0F0"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5802 364.344H85.9922V367.932H89.5802V364.344Z",
    fill: "#F0F0F0"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5802 370.367H85.9922V373.955H89.5802V370.367Z",
    fill: "#F0F0F0"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5802 376.379H85.9922V379.967H89.5802V376.379Z",
    fill: "#F0F0F0"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5802 382.402H85.9922V385.99H89.5802V382.402Z",
    fill: "#F0F0F0"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5802 388.414H85.9922V392.002H89.5802V388.414Z",
    fill: "#F0F0F0"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5802 394.441H85.9922V398.029H89.5802V394.441Z",
    fill: "#F0F0F0"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5802 400.453H85.9922V404.041H89.5802V400.453Z",
    fill: "#F0F0F0"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5802 406.477H85.9922V410.065H89.5802V406.477Z",
    fill: "#F0F0F0"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5802 412.488H85.9922V416.076H89.5802V412.488Z",
    fill: "#F0F0F0"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5802 418.512H85.9922V422.1H89.5802V418.512Z",
    fill: "#F0F0F0"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5802 424.523H85.9922V428.111H89.5802V424.523Z",
    fill: "#F0F0F0"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5802 430.547H85.9922V434.135H89.5802V430.547Z",
    fill: "#F0F0F0"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5802 436.559H85.9922V440.147H89.5802V436.559Z",
    fill: "#F0F0F0"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5802 442.57H85.9922V446.158H89.5802V442.57Z",
    fill: "#F0F0F0"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M121.248 366.145H117.66V369.733H121.248V366.145Z",
    fill: "#F0F0F0"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M121.248 372.156H117.66V375.744H121.248V372.156Z",
    fill: "#F0F0F0"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M121.248 378.18H117.66V381.768H121.248V378.18Z",
    fill: "#F0F0F0"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M121.248 384.191H117.66V387.779H121.248V384.191Z",
    fill: "#F0F0F0"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M121.248 390.215H117.66V393.803H121.248V390.215Z",
    fill: "#F0F0F0"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M121.248 396.227H117.66V399.815H121.248V396.227Z",
    fill: "#F0F0F0"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M121.248 402.254H117.66V405.842H121.248V402.254Z",
    fill: "#F0F0F0"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M121.248 408.266H117.66V411.854H121.248V408.266Z",
    fill: "#F0F0F0"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M121.248 414.289H117.66V417.877H121.248V414.289Z",
    fill: "#F0F0F0"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M121.248 420.301H117.66V423.889H121.248V420.301Z",
    fill: "#F0F0F0"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M121.248 438.359H117.66V441.947H121.248V438.359Z",
    fill: "#F0F0F0"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M126.948 366.145H123.36V369.733H126.948V366.145Z",
    fill: "#F0F0F0"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M126.948 372.156H123.36V375.744H126.948V372.156Z",
    fill: "#F0F0F0"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M126.948 378.18H123.36V381.768H126.948V378.18Z",
    fill: "#F0F0F0"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M126.948 384.191H123.36V387.779H126.948V384.191Z",
    fill: "#F0F0F0"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M126.948 390.215H123.36V393.803H126.948V390.215Z",
    fill: "#F0F0F0"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M126.948 396.227H123.36V399.815H126.948V396.227Z",
    fill: "#F0F0F0"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M126.948 402.254H123.36V405.842H126.948V402.254Z",
    fill: "#F0F0F0"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M126.948 408.266H123.36V411.854H126.948V408.266Z",
    fill: "#F0F0F0"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M126.948 414.289H123.36V417.877H126.948V414.289Z",
    fill: "#F0F0F0"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M126.948 432.336H123.36V435.924H126.948V432.336Z",
    fill: "#F0F0F0"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M126.948 438.359H123.36V441.947H126.948V438.359Z",
    fill: "#F0F0F0"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M132.648 366.145H129.06V369.733H132.648V366.145Z",
    fill: "#F0F0F0"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M132.648 372.156H129.06V375.744H132.648V372.156Z",
    fill: "#F0F0F0"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M132.648 378.18H129.06V381.768H132.648V378.18Z",
    fill: "#F0F0F0"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M132.648 384.191H129.06V387.779H132.648V384.191Z",
    fill: "#F0F0F0"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M132.648 390.215H129.06V393.803H132.648V390.215Z",
    fill: "#F0F0F0"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M132.648 396.227H129.06V399.815H132.648V396.227Z",
    fill: "#F0F0F0"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M132.648 402.254H129.06V405.842H132.648V402.254Z",
    fill: "#F0F0F0"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M132.648 408.266H129.06V411.854H132.648V408.266Z",
    fill: "#F0F0F0"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M132.648 426.324H129.06V429.912H132.648V426.324Z",
    fill: "#F0F0F0"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M132.648 432.336H129.06V435.924H132.648V432.336Z",
    fill: "#F0F0F0"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M132.648 438.359H129.06V441.947H132.648V438.359Z",
    fill: "#F0F0F0"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M185.652 274.715H182.064V278.303H185.652V274.715Z",
    fill: "#F0F0F0"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M185.652 280.738H182.064V284.326H185.652V280.738Z",
    fill: "#F0F0F0"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M185.652 286.754H182.064V290.342H185.652V286.754Z",
    fill: "#F0F0F0"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M185.652 292.777H182.064V296.365H185.652V292.777Z",
    fill: "#F0F0F0"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M185.652 298.789H182.064V302.377H185.652V298.789Z",
    fill: "#F0F0F0"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M185.652 304.801H182.064V308.389H185.652V304.801Z",
    fill: "#F0F0F0"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M185.652 310.824H182.064V314.412H185.652V310.824Z",
    fill: "#F0F0F0"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M185.652 316.836H182.064V320.424H185.652V316.836Z",
    fill: "#F0F0F0"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M185.652 322.859H182.064V326.447H185.652V322.859Z",
    fill: "#F0F0F0"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M185.652 328.871H182.064V332.459H185.652V328.871Z",
    fill: "#F0F0F0"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M185.652 334.895H182.064V338.483H185.652V334.895Z",
    fill: "#F0F0F0"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M185.652 340.906H182.064V344.494H185.652V340.906Z",
    fill: "#F0F0F0"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M185.652 346.934H182.064V350.522H185.652V346.934Z",
    fill: "#F0F0F0"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M185.652 352.945H182.064V356.533H185.652V352.945Z",
    fill: "#F0F0F0"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M185.652 358.969H182.064V362.557H185.652V358.969Z",
    fill: "#F0F0F0"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M185.652 364.98H182.064V368.568H185.652V364.98Z",
    fill: "#F0F0F0"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M185.652 371.004H182.064V374.592H185.652V371.004Z",
    fill: "#F0F0F0"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M185.652 383.039H182.064V386.627H185.652V383.039Z",
    fill: "#F0F0F0"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M185.652 389.051H182.064V392.639H185.652V389.051Z",
    fill: "#F0F0F0"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M185.652 395.074H182.064V398.662H185.652V395.074Z",
    fill: "#F0F0F0"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M185.652 401.09H182.064V404.678H185.652V401.09Z",
    fill: "#F0F0F0"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M185.652 407.102H182.064V410.69H185.652V407.102Z",
    fill: "#F0F0F0"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M191.352 274.715H187.764V278.303H191.352V274.715Z",
    fill: "#F0F0F0"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M191.352 280.738H187.764V284.326H191.352V280.738Z",
    fill: "#F0F0F0"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M191.352 286.754H187.764V290.342H191.352V286.754Z",
    fill: "#F0F0F0"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M191.352 292.777H187.764V296.365H191.352V292.777Z",
    fill: "#F0F0F0"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M191.352 298.789H187.764V302.377H191.352V298.789Z",
    fill: "#F0F0F0"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M191.352 304.801H187.764V308.389H191.352V304.801Z",
    fill: "#F0F0F0"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M191.352 310.824H187.764V314.412H191.352V310.824Z",
    fill: "#F0F0F0"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M191.352 316.836H187.764V320.424H191.352V316.836Z",
    fill: "#F0F0F0"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M191.352 322.859H187.764V326.447H191.352V322.859Z",
    fill: "#F0F0F0"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M191.352 328.871H187.764V332.459H191.352V328.871Z",
    fill: "#F0F0F0"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M191.352 334.895H187.764V338.483H191.352V334.895Z",
    fill: "#F0F0F0"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M191.352 340.906H187.764V344.494H191.352V340.906Z",
    fill: "#F0F0F0"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M191.352 346.934H187.764V350.522H191.352V346.934Z",
    fill: "#F0F0F0"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M191.352 352.945H187.764V356.533H191.352V352.945Z",
    fill: "#F0F0F0"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M191.352 358.969H187.764V362.557H191.352V358.969Z",
    fill: "#F0F0F0"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M191.352 364.98H187.764V368.568H191.352V364.98Z",
    fill: "#F0F0F0"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M191.352 401.09H187.764V404.678H191.352V401.09Z",
    fill: "#F0F0F0"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M191.352 407.102H187.764V410.69H191.352V407.102Z",
    fill: "#F0F0F0"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M197.052 274.715H193.464V278.303H197.052V274.715Z",
    fill: "#F0F0F0"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M197.052 280.738H193.464V284.326H197.052V280.738Z",
    fill: "#F0F0F0"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M197.052 286.754H193.464V290.342H197.052V286.754Z",
    fill: "#F0F0F0"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M197.052 292.777H193.464V296.365H197.052V292.777Z",
    fill: "#F0F0F0"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M197.052 298.789H193.464V302.377H197.052V298.789Z",
    fill: "#F0F0F0"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M197.052 304.801H193.464V308.389H197.052V304.801Z",
    fill: "#F0F0F0"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M197.052 310.824H193.464V314.412H197.052V310.824Z",
    fill: "#F0F0F0"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M197.052 316.836H193.464V320.424H197.052V316.836Z",
    fill: "#F0F0F0"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M197.052 322.859H193.464V326.447H197.052V322.859Z",
    fill: "#F0F0F0"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M197.052 328.871H193.464V332.459H197.052V328.871Z",
    fill: "#F0F0F0"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M197.052 334.895H193.464V338.483H197.052V334.895Z",
    fill: "#F0F0F0"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M197.052 340.906H193.464V344.494H197.052V340.906Z",
    fill: "#F0F0F0"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M197.052 346.934H193.464V350.522H197.052V346.934Z",
    fill: "#F0F0F0"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M197.052 352.945H193.464V356.533H197.052V352.945Z",
    fill: "#F0F0F0"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M197.052 358.969H193.464V362.557H197.052V358.969Z",
    fill: "#F0F0F0"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M197.052 364.98H193.464V368.568H197.052V364.98Z",
    fill: "#F0F0F0"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M197.052 377.016H193.464V380.604H197.052V377.016Z",
    fill: "#F0F0F0"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M197.052 383.039H193.464V386.627H197.052V383.039Z",
    fill: "#F0F0F0"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M197.052 389.051H193.464V392.639H197.052V389.051Z",
    fill: "#F0F0F0"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M197.052 395.074H193.464V398.662H197.052V395.074Z",
    fill: "#F0F0F0"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M197.052 407.102H193.464V410.69H197.052V407.102Z",
    fill: "#F0F0F0"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M164.952 350.52H161.364V354.108H164.952V350.52Z",
    fill: "#F0F0F0"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M164.952 356.531H161.364V360.119H164.952V356.531Z",
    fill: "#F0F0F0"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M164.952 362.555H161.364V366.143H164.952V362.555Z",
    fill: "#F0F0F0"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M164.952 368.566H161.364V372.154H164.952V368.566Z",
    fill: "#F0F0F0"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M164.952 374.594H161.364V378.182H164.952V374.594Z",
    fill: "#F0F0F0"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M164.952 380.605H161.364V384.193H164.952V380.605Z",
    fill: "#F0F0F0"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M164.952 386.629H161.364V390.217H164.952V386.629Z",
    fill: "#F0F0F0"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M164.952 398.664H161.364V402.252H164.952V398.664Z",
    fill: "#F0F0F0"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M164.952 404.676H161.364V408.264H164.952V404.676Z",
    fill: "#F0F0F0"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M164.952 410.699H161.364V414.287H164.952V410.699Z",
    fill: "#F0F0F0"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M164.952 416.711H161.364V420.299H164.952V416.711Z",
    fill: "#F0F0F0"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M164.952 422.723H161.364V426.311H164.952V422.723Z",
    fill: "#F0F0F0"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M164.952 428.746H161.364V432.334H164.952V428.746Z",
    fill: "#F0F0F0"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M164.952 434.762H161.364V438.35H164.952V434.762Z",
    fill: "#F0F0F0"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M164.952 440.785H161.364V444.373H164.952V440.785Z",
    fill: "#F0F0F0"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M170.652 350.52H167.064V354.108H170.652V350.52Z",
    fill: "#F0F0F0"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M170.652 356.531H167.064V360.119H170.652V356.531Z",
    fill: "#F0F0F0"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M170.652 362.555H167.064V366.143H170.652V362.555Z",
    fill: "#F0F0F0"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M170.652 368.566H167.064V372.154H170.652V368.566Z",
    fill: "#F0F0F0"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M170.652 374.594H167.064V378.182H170.652V374.594Z",
    fill: "#F0F0F0"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M170.652 380.605H167.064V384.193H170.652V380.605Z",
    fill: "#F0F0F0"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M170.652 398.664H167.064V402.252H170.652V398.664Z",
    fill: "#F0F0F0"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M170.652 404.676H167.064V408.264H170.652V404.676Z",
    fill: "#F0F0F0"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M170.652 410.699H167.064V414.287H170.652V410.699Z",
    fill: "#F0F0F0"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M170.652 416.711H167.064V420.299H170.652V416.711Z",
    fill: "#F0F0F0"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M170.652 422.723H167.064V426.311H170.652V422.723Z",
    fill: "#F0F0F0"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M170.652 428.746H167.064V432.334H170.652V428.746Z",
    fill: "#F0F0F0"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M170.652 434.762H167.064V438.35H170.652V434.762Z",
    fill: "#F0F0F0"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M170.652 440.785H167.064V444.373H170.652V440.785Z",
    fill: "#F0F0F0"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M176.364 350.52H172.776V354.108H176.364V350.52Z",
    fill: "#F0F0F0"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M176.364 356.531H172.776V360.119H176.364V356.531Z",
    fill: "#F0F0F0"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M176.364 362.555H172.776V366.143H176.364V362.555Z",
    fill: "#F0F0F0"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M176.364 368.566H172.776V372.154H176.364V368.566Z",
    fill: "#F0F0F0"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M176.364 374.594H172.776V378.182H176.364V374.594Z",
    fill: "#F0F0F0"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M176.364 380.605H172.776V384.193H176.364V380.605Z",
    fill: "#F0F0F0"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M176.364 392.641H172.776V396.229H176.364V392.641Z",
    fill: "#F0F0F0"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M176.364 398.664H172.776V402.252H176.364V398.664Z",
    fill: "#F0F0F0"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M176.364 404.676H172.776V408.264H176.364V404.676Z",
    fill: "#F0F0F0"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M176.364 410.699H172.776V414.287H176.364V410.699Z",
    fill: "#F0F0F0"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M176.364 416.711H172.776V420.299H176.364V416.711Z",
    fill: "#F0F0F0"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M176.364 422.723H172.776V426.311H176.364V422.723Z",
    fill: "#F0F0F0"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M176.364 428.746H172.776V432.334H176.364V428.746Z",
    fill: "#F0F0F0"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M176.364 434.762H172.776V438.35H176.364V434.762Z",
    fill: "#F0F0F0"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M176.364 440.785H172.776V444.373H176.364V440.785Z",
    fill: "#F0F0F0"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M296.496 316.836H292.908V320.424H296.496V316.836Z",
    fill: "#F0F0F0"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M296.496 322.859H292.908V326.447H296.496V322.859Z",
    fill: "#F0F0F0"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M296.496 328.871H292.908V332.459H296.496V328.871Z",
    fill: "#F0F0F0"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M296.496 334.895H292.908V338.483H296.496V334.895Z",
    fill: "#F0F0F0"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M296.496 340.906H292.908V344.494H296.496V340.906Z",
    fill: "#F0F0F0"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M296.496 346.934H292.908V350.522H296.496V346.934Z",
    fill: "#F0F0F0"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M296.496 352.945H292.908V356.533H296.496V352.945Z",
    fill: "#F0F0F0"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M296.496 358.969H292.908V362.557H296.496V358.969Z",
    fill: "#F0F0F0"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M296.496 364.98H292.908V368.568H296.496V364.98Z",
    fill: "#F0F0F0"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M296.496 371.004H292.908V374.592H296.496V371.004Z",
    fill: "#F0F0F0"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M296.496 377.016H292.908V380.604H296.496V377.016Z",
    fill: "#F0F0F0"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M296.496 383.039H292.908V386.627H296.496V383.039Z",
    fill: "#F0F0F0"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M296.496 389.051H292.908V392.639H296.496V389.051Z",
    fill: "#F0F0F0"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M296.496 401.09H292.908V404.678H296.496V401.09Z",
    fill: "#F0F0F0"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M296.496 407.102H292.908V410.69H296.496V407.102Z",
    fill: "#F0F0F0"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M296.496 413.125H292.908V416.713H296.496V413.125Z",
    fill: "#F0F0F0"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M296.496 419.137H292.908V422.725H296.496V419.137Z",
    fill: "#F0F0F0"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M296.496 431.172H292.908V434.76H296.496V431.172Z",
    fill: "#F0F0F0"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M296.496 437.195H292.908V440.783H296.496V437.195Z",
    fill: "#F0F0F0"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M296.496 443.207H292.908V446.795H296.496V443.207Z",
    fill: "#F0F0F0"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M302.196 316.836H298.608V320.424H302.196V316.836Z",
    fill: "#F0F0F0"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M302.196 322.859H298.608V326.447H302.196V322.859Z",
    fill: "#F0F0F0"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M302.196 328.871H298.608V332.459H302.196V328.871Z",
    fill: "#F0F0F0"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M302.196 334.895H298.608V338.483H302.196V334.895Z",
    fill: "#F0F0F0"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M302.196 340.906H298.608V344.494H302.196V340.906Z",
    fill: "#F0F0F0"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M302.196 346.934H298.608V350.522H302.196V346.934Z",
    fill: "#F0F0F0"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M302.196 352.945H298.608V356.533H302.196V352.945Z",
    fill: "#F0F0F0"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M302.196 358.969H298.608V362.557H302.196V358.969Z",
    fill: "#F0F0F0"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M302.196 364.98H298.608V368.568H302.196V364.98Z",
    fill: "#F0F0F0"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M302.196 371.004H298.608V374.592H302.196V371.004Z",
    fill: "#F0F0F0"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M302.196 377.016H298.608V380.604H302.196V377.016Z",
    fill: "#F0F0F0"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M302.196 383.039H298.608V386.627H302.196V383.039Z",
    fill: "#F0F0F0"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M302.196 389.051H298.608V392.639H302.196V389.051Z",
    fill: "#F0F0F0"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M302.196 407.102H298.608V410.69H302.196V407.102Z",
    fill: "#F0F0F0"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M302.196 413.125H298.608V416.713H302.196V413.125Z",
    fill: "#F0F0F0"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M302.196 425.16H298.608V428.748H302.196V425.16Z",
    fill: "#F0F0F0"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M302.196 431.172H298.608V434.76H302.196V431.172Z",
    fill: "#F0F0F0"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M302.196 437.195H298.608V440.783H302.196V437.195Z",
    fill: "#F0F0F0"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M302.196 443.207H298.608V446.795H302.196V443.207Z",
    fill: "#F0F0F0"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M307.908 316.836H304.32V320.424H307.908V316.836Z",
    fill: "#F0F0F0"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M307.908 322.859H304.32V326.447H307.908V322.859Z",
    fill: "#F0F0F0"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M307.908 328.871H304.32V332.459H307.908V328.871Z",
    fill: "#F0F0F0"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M307.908 334.895H304.32V338.483H307.908V334.895Z",
    fill: "#F0F0F0"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M307.908 340.906H304.32V344.494H307.908V340.906Z",
    fill: "#F0F0F0"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M307.908 346.934H304.32V350.522H307.908V346.934Z",
    fill: "#F0F0F0"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M307.908 352.945H304.32V356.533H307.908V352.945Z",
    fill: "#F0F0F0"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M307.908 358.969H304.32V362.557H307.908V358.969Z",
    fill: "#F0F0F0"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M307.908 364.98H304.32V368.568H307.908V364.98Z",
    fill: "#F0F0F0"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M307.908 371.004H304.32V374.592H307.908V371.004Z",
    fill: "#F0F0F0"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M307.908 377.016H304.32V380.604H307.908V377.016Z",
    fill: "#F0F0F0"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M307.908 383.039H304.32V386.627H307.908V383.039Z",
    fill: "#F0F0F0"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M307.908 389.051H304.32V392.639H307.908V389.051Z",
    fill: "#F0F0F0"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M307.908 395.074H304.32V398.662H307.908V395.074Z",
    fill: "#F0F0F0"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M307.908 407.102H304.32V410.69H307.908V407.102Z",
    fill: "#F0F0F0"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M307.908 419.137H304.32V422.725H307.908V419.137Z",
    fill: "#F0F0F0"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M307.908 425.16H304.32V428.748H307.908V425.16Z",
    fill: "#F0F0F0"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M307.908 431.172H304.32V434.76H307.908V431.172Z",
    fill: "#F0F0F0"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M307.908 437.195H304.32V440.783H307.908V437.195Z",
    fill: "#F0F0F0"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M307.908 443.207H304.32V446.795H307.908V443.207Z",
    fill: "#F0F0F0"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M273.276 351.156H269.688V354.744H273.276V351.156Z",
    fill: "#F0F0F0"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M273.276 357.168H269.688V360.756H273.276V357.168Z",
    fill: "#F0F0F0"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M273.276 363.191H269.688V366.779H273.276V363.191Z",
    fill: "#F0F0F0"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M273.276 369.203H269.688V372.791H273.276V369.203Z",
    fill: "#F0F0F0"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M273.276 375.227H269.688V378.815H273.276V375.227Z",
    fill: "#F0F0F0"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M273.276 381.238H269.688V384.826H273.276V381.238Z",
    fill: "#F0F0F0"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M273.276 399.289H269.688V402.877H273.276V399.289Z",
    fill: "#F0F0F0"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M273.276 405.312H269.688V408.9H273.276V405.312Z",
    fill: "#F0F0F0"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M273.276 411.324H269.688V414.912H273.276V411.324Z",
    fill: "#F0F0F0"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M273.276 417.348H269.688V420.936H273.276V417.348Z",
    fill: "#F0F0F0"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M273.276 423.359H269.688V426.947H273.276V423.359Z",
    fill: "#F0F0F0"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M273.276 429.383H269.688V432.971H273.276V429.383Z",
    fill: "#F0F0F0"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M273.276 435.395H269.688V438.983H273.276V435.395Z",
    fill: "#F0F0F0"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M278.976 351.156H275.388V354.744H278.976V351.156Z",
    fill: "#F0F0F0"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M278.976 357.168H275.388V360.756H278.976V357.168Z",
    fill: "#F0F0F0"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M278.976 363.191H275.388V366.779H278.976V363.191Z",
    fill: "#F0F0F0"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M278.976 369.203H275.388V372.791H278.976V369.203Z",
    fill: "#F0F0F0"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M278.976 375.227H275.388V378.815H278.976V375.227Z",
    fill: "#F0F0F0"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M278.976 381.238H275.388V384.826H278.976V381.238Z",
    fill: "#F0F0F0"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M278.976 399.289H275.388V402.877H278.976V399.289Z",
    fill: "#F0F0F0"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M278.976 405.312H275.388V408.9H278.976V405.312Z",
    fill: "#F0F0F0"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M278.976 411.324H275.388V414.912H278.976V411.324Z",
    fill: "#F0F0F0"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M278.976 417.348H275.388V420.936H278.976V417.348Z",
    fill: "#F0F0F0"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M278.976 423.359H275.388V426.947H278.976V423.359Z",
    fill: "#F0F0F0"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M278.976 429.383H275.388V432.971H278.976V429.383Z",
    fill: "#F0F0F0"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M278.976 441.422H275.388V445.01H278.976V441.422Z",
    fill: "#F0F0F0"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M468.372 324.648H464.784V328.236H468.372V324.648Z",
    fill: "#F0F0F0"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M468.372 330.672H464.784V334.26H468.372V330.672Z",
    fill: "#F0F0F0"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M468.372 336.684H464.784V340.272H468.372V336.684Z",
    fill: "#F0F0F0"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M468.372 342.707H464.784V346.295H468.372V342.707Z",
    fill: "#F0F0F0"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M468.372 348.719H464.784V352.307H468.372V348.719Z",
    fill: "#F0F0F0"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M468.372 354.742H464.784V358.33H468.372V354.742Z",
    fill: "#F0F0F0"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M468.372 360.758H464.784V364.346H468.372V360.758Z",
    fill: "#F0F0F0"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M468.372 366.781H464.784V370.369H468.372V366.781Z",
    fill: "#F0F0F0"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M468.372 372.793H464.784V376.381H468.372V372.793Z",
    fill: "#F0F0F0"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M468.372 378.816H464.784V382.404H468.372V378.816Z",
    fill: "#F0F0F0"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M468.372 384.828H464.784V388.416H468.372V384.828Z",
    fill: "#F0F0F0"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M468.372 396.863H464.784V400.451H468.372V396.863Z",
    fill: "#F0F0F0"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M468.372 402.887H464.784V406.475H468.372V402.887Z",
    fill: "#F0F0F0"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M468.372 408.898H464.784V412.486H468.372V408.898Z",
    fill: "#F0F0F0"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M468.372 414.91H464.784V418.498H468.372V414.91Z",
    fill: "#F0F0F0"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M468.372 420.938H464.784V424.525H468.372V420.938Z",
    fill: "#F0F0F0"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M468.372 426.949H464.784V430.537H468.372V426.949Z",
    fill: "#F0F0F0"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M468.372 432.973H464.784V436.561H468.372V432.973Z",
    fill: "#F0F0F0"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M468.372 438.984H464.784V442.572H468.372V438.984Z",
    fill: "#F0F0F0"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M474.072 324.648H470.484V328.236H474.072V324.648Z",
    fill: "#F0F0F0"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M474.072 330.672H470.484V334.26H474.072V330.672Z",
    fill: "#F0F0F0"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M474.072 336.684H470.484V340.272H474.072V336.684Z",
    fill: "#F0F0F0"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M474.072 342.707H470.484V346.295H474.072V342.707Z",
    fill: "#F0F0F0"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M474.072 348.719H470.484V352.307H474.072V348.719Z",
    fill: "#F0F0F0"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M474.072 354.742H470.484V358.33H474.072V354.742Z",
    fill: "#F0F0F0"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M474.072 360.758H470.484V364.346H474.072V360.758Z",
    fill: "#F0F0F0"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M474.072 366.781H470.484V370.369H474.072V366.781Z",
    fill: "#F0F0F0"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M474.072 372.793H470.484V376.381H474.072V372.793Z",
    fill: "#F0F0F0"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M474.072 378.816H470.484V382.404H474.072V378.816Z",
    fill: "#F0F0F0"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M474.072 384.828H470.484V388.416H474.072V384.828Z",
    fill: "#F0F0F0"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M474.072 390.852H470.484V394.44H474.072V390.852Z",
    fill: "#F0F0F0"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M474.072 396.863H470.484V400.451H474.072V396.863Z",
    fill: "#F0F0F0"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M474.072 402.887H470.484V406.475H474.072V402.887Z",
    fill: "#F0F0F0"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M474.072 408.898H470.484V412.486H474.072V408.898Z",
    fill: "#F0F0F0"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M474.072 414.91H470.484V418.498H474.072V414.91Z",
    fill: "#F0F0F0"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M474.072 420.938H470.484V424.525H474.072V420.938Z",
    fill: "#F0F0F0"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M474.072 426.949H470.484V430.537H474.072V426.949Z",
    fill: "#F0F0F0"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M474.072 432.973H470.484V436.561H474.072V432.973Z",
    fill: "#F0F0F0"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M474.072 438.984H470.484V442.572H474.072V438.984Z",
    fill: "#F0F0F0"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M440.292 348.098H436.704V351.686H440.292V348.098Z",
    fill: "#F0F0F0"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M440.292 354.109H436.704V357.697H440.292V354.109Z",
    fill: "#F0F0F0"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M440.292 360.121H436.704V363.709H440.292V360.121Z",
    fill: "#F0F0F0"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M440.292 366.145H436.704V369.733H440.292V366.145Z",
    fill: "#F0F0F0"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M440.292 372.156H436.704V375.744H440.292V372.156Z",
    fill: "#F0F0F0"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M440.292 378.18H436.704V381.768H440.292V378.18Z",
    fill: "#F0F0F0"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M440.292 384.191H436.704V387.779H440.292V384.191Z",
    fill: "#F0F0F0"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M440.292 390.215H436.704V393.803H440.292V390.215Z",
    fill: "#F0F0F0"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M440.292 396.227H436.704V399.815H440.292V396.227Z",
    fill: "#F0F0F0"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M440.292 402.254H436.704V405.842H440.292V402.254Z",
    fill: "#F0F0F0"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M445.992 348.098H442.404V351.686H445.992V348.098Z",
    fill: "#F0F0F0"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M445.992 354.109H442.404V357.697H445.992V354.109Z",
    fill: "#F0F0F0"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M445.992 360.121H442.404V363.709H445.992V360.121Z",
    fill: "#F0F0F0"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M445.992 366.145H442.404V369.733H445.992V366.145Z",
    fill: "#F0F0F0"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M445.992 372.156H442.404V375.744H445.992V372.156Z",
    fill: "#F0F0F0"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M445.992 378.18H442.404V381.768H445.992V378.18Z",
    fill: "#F0F0F0"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M445.992 384.191H442.404V387.779H445.992V384.191Z",
    fill: "#F0F0F0"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M445.992 390.215H442.404V393.803H445.992V390.215Z",
    fill: "#F0F0F0"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M445.992 396.227H442.404V399.815H445.992V396.227Z",
    fill: "#F0F0F0"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M382.596 172.681C382.594 171.089 382.964 169.519 383.678 168.096C384.392 166.673 385.429 165.437 386.706 164.486C387.983 163.535 389.465 162.897 391.033 162.622C392.601 162.347 394.211 162.442 395.736 162.901C395.586 161.864 395.51 160.817 395.508 159.769C395.504 156.591 396.201 153.451 397.551 150.573C398.9 147.695 400.868 145.15 403.314 143.12C405.759 141.091 408.623 139.626 411.7 138.83C414.778 138.034 417.992 137.927 421.116 138.517C423.248 135.008 426.465 132.288 430.28 130.769C434.095 129.251 438.301 129.016 442.261 130.101C446.222 131.186 449.721 133.531 452.23 136.781C454.739 140.032 456.122 144.011 456.168 148.117H456.48C458.842 147.993 461.204 148.351 463.423 149.17C465.642 149.988 467.671 151.25 469.387 152.878C471.103 154.505 472.469 156.466 473.403 158.639C474.336 160.812 474.818 163.152 474.818 165.517C474.818 167.882 474.336 170.223 473.403 172.396C472.469 174.569 471.103 176.529 469.387 178.157C467.671 179.785 465.642 181.046 463.423 181.865C461.204 182.683 458.842 183.041 456.48 182.917H392.52C389.857 182.842 387.33 181.73 385.476 179.818C383.622 177.905 382.588 175.345 382.596 172.681Z",
    fill: "#F0F0F0"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2559 146.675C98.2559 144.946 98.9424 143.289 100.164 142.067C101.386 140.845 103.044 140.159 104.772 140.159C105.406 140.157 106.037 140.25 106.644 140.435C106.318 138.256 106.519 136.032 107.229 133.947C107.938 131.862 109.137 129.977 110.724 128.45C112.311 126.923 114.24 125.798 116.351 125.169C118.461 124.54 120.692 124.425 122.856 124.835C124.226 122.614 126.279 120.897 128.707 119.941C131.136 118.985 133.808 118.841 136.325 119.532C138.841 120.223 141.066 121.71 142.666 123.772C144.266 125.833 145.155 128.357 145.2 130.967H145.392C148.342 130.967 151.172 132.139 153.258 134.225C155.344 136.311 156.516 139.14 156.516 142.091C156.516 145.041 155.344 147.87 153.258 149.956C151.172 152.043 148.342 153.215 145.392 153.215H104.592C102.891 153.168 101.276 152.457 100.092 151.235C98.908 150.013 98.249 148.376 98.2559 146.675Z",
    fill: "#F0F0F0"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M275.052 132.877C275.052 131.817 275.473 130.801 276.222 130.051C276.972 129.302 277.988 128.881 279.048 128.881C279.454 128.877 279.858 128.934 280.248 129.049C280.186 128.652 280.154 128.251 280.152 127.849C280.168 125.616 281.066 123.479 282.651 121.906C284.236 120.332 286.379 119.449 288.612 119.449C289.135 119.454 289.657 119.502 290.172 119.593C291.006 118.223 292.263 117.162 293.753 116.57C295.244 115.977 296.886 115.886 298.433 116.308C299.98 116.731 301.347 117.645 302.329 118.913C303.311 120.181 303.854 121.733 303.876 123.337H304.008C305.816 123.337 307.549 124.055 308.828 125.333C310.106 126.612 310.824 128.345 310.824 130.153C310.824 131.961 310.106 133.694 308.828 134.973C307.549 136.251 305.816 136.969 304.008 136.969H278.94C277.882 136.941 276.879 136.494 276.15 135.727C275.421 134.96 275.026 133.935 275.052 132.877Z",
    fill: "#F0F0F0"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4721 440.903C92.4721 440.903 87.0241 422.675 98.0281 419.051C109.032 415.427 115.56 406.895 115.2 397.259C114.84 387.623 126.408 378.239 135.096 387.275C143.784 396.311 142.632 380.327 154.212 376.475C165.792 372.623 175.608 382.019 172.44 390.623C169.272 399.227 180.696 404.615 194.388 397.295C208.08 389.975 223.128 403.295 220.236 413.723C217.344 424.151 219.708 425.303 228.372 421.823C237.036 418.343 252.516 428.195 247.092 440.939C241.668 453.683 92.4721 440.903 92.4721 440.903Z",
    fill: "#E0E0E0"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M383.556 450.841C377.772 445.057 382.98 435.241 388.776 434.041C394.572 432.841 400.38 422.689 400.656 416.197C400.932 409.705 411.36 389.797 427.572 402.085C443.784 414.373 438.864 403.897 450.588 400.429C462.312 396.961 469.728 406.933 464.58 414.409C464.58 414.409 476.364 411.445 481.212 422.449C486.06 433.453 481.212 440.293 481.212 440.293C481.212 440.293 503.376 439.633 501.384 453.349C499.392 467.065 383.556 450.841 383.556 450.841Z",
    fill: "#E0E0E0"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M520.896 442.992V458.856H73.7882V442.992C73.7524 442.354 73.8467 441.715 74.0653 441.114C74.284 440.514 74.6224 439.964 75.0601 439.498C75.4978 439.032 76.0256 438.66 76.6115 438.405C77.1973 438.149 77.829 438.016 78.4682 438.012H516.216C516.855 438.016 517.487 438.149 518.073 438.405C518.659 438.66 519.187 439.032 519.624 439.498C520.062 439.964 520.4 440.514 520.619 441.114C520.838 441.715 520.932 442.354 520.896 442.992Z",
    fill: "#EBEBEB"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M127.068 438.012H99.2642V458.856H127.068V438.012Z",
    fill: "#F5F5F5"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M179.184 438.012H152.544V458.856H179.184V438.012Z",
    fill: "#F5F5F5"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M232.476 438.012H204.672V458.856H232.476V438.012Z",
    fill: "#F5F5F5"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M284.592 438.012H257.952V458.856H284.592V438.012Z",
    fill: "#F5F5F5"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M336.72 438.012H310.08V458.856H336.72V438.012Z",
    fill: "#F5F5F5"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M390.012 438.012H362.208V458.856H390.012V438.012Z",
    fill: "#F5F5F5"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M442.128 438.012H415.488V458.856H442.128V438.012Z",
    fill: "#F5F5F5"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M495.42 438.012H467.616V458.856H495.42V438.012Z",
    fill: "#F5F5F5"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M300 513.07C428.499 513.07 532.668 506.989 532.668 499.486C532.668 491.984 428.499 485.902 300 485.902C171.501 485.902 67.332 491.984 67.332 499.486C67.332 506.989 171.501 513.07 300 513.07Z",
    fill: "#F5F5F5"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M113.616 466.896H112.416C112.416 465.324 113.736 428.112 120.216 421.8C126.912 415.284 134.784 421.704 134.856 421.8L134.088 422.724C133.8 422.484 126.972 416.94 121.056 422.724C114.912 428.58 113.628 466.512 113.616 466.896Z",
    fill: "#4A1FB8"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M113.088 474.361L111.888 474.241C111.888 473.797 116.064 429.121 99.8882 410.557L100.8 409.777C117.312 428.725 113.268 472.501 113.088 474.361Z",
    fill: "#4A1FB8"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M113.46 469.585C113.328 467.473 110.208 417.757 122.676 406.285L123.492 407.173C111.492 418.249 114.624 468.997 114.66 469.501L113.46 469.585Z",
    fill: "#4A1FB8"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M111.888 469.55C111.888 469.214 111.504 435.866 102.684 430.814C101.942 430.321 101.091 430.015 100.205 429.923C99.319 429.832 98.4237 429.956 97.5962 430.286C92.4242 432.422 89.6761 442.286 89.6521 442.394L88.4521 442.082C88.5721 441.65 91.3922 431.534 97.0922 429.182C98.0904 428.78 99.1705 428.623 100.242 428.726C101.313 428.828 102.344 429.186 103.248 429.77C112.656 435.158 113.04 468.17 113.052 469.538L111.888 469.55Z",
    fill: "#4A1FB8"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M115.524 469.572C115.524 468.504 114.096 443.172 121.284 433.776C123.204 431.268 125.352 430.092 127.668 430.248C132.804 430.608 136.776 437.544 136.944 437.844L135.9 438.432C135.9 438.36 132.072 431.76 127.584 431.448C125.7 431.316 123.9 432.348 122.244 434.508C115.32 443.544 116.712 469.308 116.724 469.512L115.524 469.572Z",
    fill: "#4A1FB8"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M114.24 473.076L113.04 472.992C113.04 472.38 117.552 412.104 110.136 402.072L111.096 401.352C118.8 411.744 114.432 470.58 114.24 473.076Z",
    fill: "#4A1FB8"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0881 435.241C95.0881 435.241 99.6841 436.933 98.3161 440.929C96.9481 444.925 82.4281 451.513 82.4281 451.513C82.4281 451.513 76.3441 445.933 81.9241 436.861C87.5041 427.789 94.9681 432.385 95.0881 435.241Z",
    fill: "#4A1FB8"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M95.0881 435.241C95.0881 435.241 99.6841 436.933 98.3161 440.929C96.9481 444.925 82.4281 451.513 82.4281 451.513C82.4281 451.513 76.3441 445.933 81.9241 436.861C87.5041 427.789 94.9681 432.385 95.0881 435.241Z",
    fill: "white"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M115.068 427.632C115.068 427.632 110.172 427.428 109.896 431.64C109.62 435.852 120.492 447.528 120.492 447.528C120.492 447.528 128.256 444.72 126.588 434.196C124.92 423.672 116.28 425.028 115.068 427.632Z",
    fill: "#4A1FB8"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M115.068 427.632C115.068 427.632 110.172 427.428 109.896 431.64C109.62 435.852 120.492 447.528 120.492 447.528C120.492 447.528 128.256 444.72 126.588 434.196C124.92 423.672 116.28 425.028 115.068 427.632Z",
    fill: "white"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M119.208 407.436C119.208 407.436 115.944 407.088 116.208 405.108C116.472 403.128 128.892 398.004 136.224 406.308C136.224 406.308 131.532 414.372 124.752 414.468C117.972 414.564 119.208 407.436 119.208 407.436Z",
    fill: "#4A1FB8"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M119.208 407.436C119.208 407.436 115.944 407.088 116.208 405.108C116.472 403.128 128.892 398.004 136.224 406.308C136.224 406.308 131.532 414.372 124.752 414.468C117.972 414.564 119.208 407.436 119.208 407.436Z",
    fill: "white"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M113.136 402.612C113.136 402.612 116.088 404.04 116.916 402.216C117.744 400.392 109.908 389.484 99.3122 392.616C99.3122 392.616 99.0362 401.94 104.736 405.612C110.436 409.284 113.136 402.612 113.136 402.612Z",
    fill: "#4A1FB8"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.136 402.612C113.136 402.612 116.088 404.04 116.916 402.216C117.744 400.392 109.908 389.484 99.3122 392.616C99.3122 392.616 99.0362 401.94 104.736 405.612C110.436 409.284 113.136 402.612 113.136 402.612Z",
    fill: "white"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M128.58 433.634C128.58 433.634 126.324 431.822 128.76 430.934C131.196 430.046 143.16 430.298 143.232 442.106C143.232 442.106 129.348 444.41 127.632 439.91C125.916 435.41 128.58 433.634 128.58 433.634Z",
    fill: "#4A1FB8"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M128.58 433.634C128.58 433.634 126.324 431.822 128.76 430.934C131.196 430.046 143.16 430.298 143.232 442.106C143.232 442.106 129.348 444.41 127.632 439.91C125.916 435.41 128.58 433.634 128.58 433.634Z",
    fill: "white"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M100.26 407.15C100.26 407.15 102.516 405.326 100.08 404.438C97.6439 403.55 85.6799 403.802 85.6079 415.622C85.6079 415.622 99.4919 417.926 101.208 413.426C102.924 408.926 100.26 407.15 100.26 407.15Z",
    fill: "#4A1FB8"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M100.26 407.15C100.26 407.15 102.516 405.326 100.08 404.438C97.6439 403.55 85.6799 403.802 85.6079 415.622C85.6079 415.622 99.4919 417.926 101.208 413.426C102.924 408.926 100.26 407.15 100.26 407.15Z",
    fill: "white"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M107.604 416.666C107.604 416.666 107.796 414.446 106.02 415.322C104.244 416.198 98.0163 422.894 104.46 429.254C104.46 429.254 113.136 422.822 111.576 419.486C110.016 416.15 107.604 416.666 107.604 416.666Z",
    fill: "#4A1FB8"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M107.604 416.666C107.604 416.666 107.796 414.446 106.02 415.322C104.244 416.198 98.0163 422.894 104.46 429.254C104.46 429.254 113.136 422.822 111.576 419.486C110.016 416.15 107.604 416.666 107.604 416.666Z",
    fill: "white"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M130.596 419.81C130.596 419.81 129.24 418.046 131.22 417.83C133.2 417.614 142.02 419.966 139.968 428.786C139.968 428.786 129.168 427.97 128.736 424.31C128.304 420.65 130.596 419.81 130.596 419.81Z",
    fill: "#4A1FB8"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M130.596 419.81C130.596 419.81 129.24 418.046 131.22 417.83C133.2 417.614 142.02 419.966 139.968 428.786C139.968 428.786 129.168 427.97 128.736 424.31C128.304 420.65 130.596 419.81 130.596 419.81Z",
    fill: "white"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M94.236 502.271H131.16L135.144 461.855H90.252L94.236 502.271Z",
    fill: "#263238"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2843 466.309H137.112V457.393H88.2843V466.309Z",
    fill: "#263238"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M88.2843 466.309H137.112V457.393H88.2843V466.309Z",
    fill: "white"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M208.308 172.681H176.4L176.124 169.453C176.114 169.348 176.126 169.242 176.16 169.142C176.193 169.041 176.247 168.949 176.318 168.871C176.39 168.793 176.476 168.731 176.573 168.689C176.67 168.646 176.774 168.625 176.88 168.625H207.192C207.417 168.63 207.633 168.716 207.799 168.869C207.964 169.021 208.069 169.229 208.092 169.453L208.308 172.681Z",
    fill: "#263238"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M172.308 172.681H140.4L140.124 169.453C140.114 169.348 140.126 169.242 140.16 169.142C140.193 169.041 140.247 168.949 140.318 168.871C140.39 168.793 140.476 168.731 140.573 168.689C140.67 168.646 140.774 168.625 140.88 168.625H171.192C171.417 168.63 171.633 168.716 171.799 168.869C171.964 169.021 172.069 169.229 172.092 169.453L172.308 172.681Z",
    fill: "#263238"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M426.684 170.282H111.324C110.315 170.265 109.313 170.46 108.384 170.855C107.454 171.25 106.619 171.836 105.93 172.575C105.242 173.314 104.718 174.189 104.39 175.144C104.062 176.099 103.939 177.113 104.028 178.118L121.56 385.466C121.787 387.601 122.789 389.579 124.377 391.024C125.966 392.468 128.029 393.279 130.176 393.302H445.536C446.546 393.32 447.548 393.125 448.477 392.73C449.406 392.335 450.242 391.749 450.93 391.01C451.618 390.271 452.143 389.395 452.471 388.44C452.798 387.485 452.922 386.472 452.832 385.466L435.3 178.118C435.076 175.982 434.075 174.003 432.486 172.558C430.897 171.113 428.832 170.303 426.684 170.282Z",
    fill: "#263238"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M445.536 393.302H134.976C132.829 393.279 130.766 392.468 129.177 391.024C127.589 389.579 126.586 387.601 126.36 385.466L108.828 178.118C108.739 177.113 108.862 176.099 109.19 175.144C109.517 174.189 110.042 173.314 110.73 172.575C111.418 171.836 112.254 171.25 113.183 170.855C114.113 170.46 115.115 170.265 116.124 170.282H426.684C428.832 170.303 430.897 171.113 432.486 172.558C434.074 174.003 435.076 175.982 435.3 178.118L452.832 385.466C452.921 386.472 452.798 387.485 452.47 388.44C452.143 389.395 451.618 390.271 450.93 391.01C450.242 391.749 449.406 392.335 448.477 392.73C447.547 393.125 446.546 393.32 445.536 393.302Z",
    fill: "white"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M430.5 386.859H139.092L121.332 176.715H412.74L430.5 386.859Z",
    fill: "#4A1FB8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M125.424 277.655C125.353 277.086 125.08 276.562 124.655 276.176C124.23 275.791 123.681 275.571 123.108 275.555C122.837 275.549 122.568 275.6 122.318 275.705C122.068 275.811 121.843 275.968 121.659 276.166C121.474 276.364 121.333 276.6 121.246 276.856C121.159 277.113 121.127 277.385 121.152 277.655C121.221 278.226 121.493 278.754 121.918 279.141C122.343 279.529 122.893 279.751 123.468 279.767C123.74 279.774 124.011 279.722 124.261 279.616C124.512 279.51 124.737 279.352 124.922 279.152C125.107 278.953 125.248 278.716 125.334 278.458C125.421 278.2 125.451 277.926 125.424 277.655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M123.984 285.91C123.849 285.908 123.714 285.934 123.589 285.988C123.465 286.041 123.353 286.12 123.261 286.22C123.169 286.32 123.1 286.438 123.057 286.567C123.014 286.695 122.999 286.831 123.012 286.966C123.048 287.259 123.189 287.528 123.411 287.723C123.632 287.918 123.917 288.024 124.212 288.022C124.348 288.025 124.483 287.998 124.608 287.945C124.734 287.892 124.846 287.813 124.939 287.713C125.032 287.614 125.102 287.496 125.147 287.367C125.191 287.238 125.208 287.102 125.196 286.966C125.161 286.672 125.017 286.4 124.793 286.205C124.569 286.01 124.281 285.905 123.984 285.91Z",
    fill: "black"
  }))), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M438.936 281.786C439.016 282.615 438.919 283.451 438.652 284.24C438.385 285.029 437.954 285.752 437.387 286.362C436.82 286.972 436.13 287.455 435.363 287.779C434.596 288.103 433.769 288.261 432.936 288.242C431.167 288.225 429.467 287.557 428.159 286.366C426.851 285.176 426.027 283.545 425.844 281.786C425.764 280.957 425.861 280.121 426.128 279.333C426.395 278.545 426.826 277.822 427.394 277.213C427.961 276.604 428.651 276.122 429.418 275.799C430.185 275.477 431.012 275.321 431.844 275.342C433.611 275.358 435.31 276.024 436.618 277.213C437.926 278.401 438.751 280.028 438.936 281.786Z",
    fill: "black"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M108.852 204.986H106.8C106.577 204.982 106.363 204.897 106.197 204.747C106.032 204.597 105.926 204.392 105.9 204.17L104.4 186.89C104.392 186.785 104.406 186.679 104.441 186.58C104.476 186.48 104.531 186.389 104.603 186.312C104.676 186.235 104.763 186.174 104.861 186.133C104.958 186.092 105.063 186.072 105.168 186.074H107.22C107.444 186.079 107.658 186.164 107.823 186.314C107.989 186.464 108.094 186.669 108.12 186.89L109.584 204.17C109.594 204.273 109.583 204.376 109.551 204.474C109.519 204.572 109.466 204.662 109.398 204.739C109.329 204.816 109.245 204.878 109.151 204.92C109.057 204.963 108.955 204.985 108.852 204.986Z",
    fill: "#263238"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M108.852 204.986H106.8C106.577 204.982 106.363 204.897 106.197 204.747C106.032 204.597 105.926 204.392 105.9 204.17L104.4 186.89C104.392 186.785 104.406 186.679 104.441 186.58C104.476 186.48 104.531 186.389 104.603 186.312C104.676 186.235 104.763 186.174 104.861 186.133C104.958 186.092 105.063 186.072 105.168 186.074H107.22C107.444 186.079 107.658 186.164 107.823 186.314C107.989 186.464 108.094 186.669 108.12 186.89L109.584 204.17C109.594 204.273 109.583 204.376 109.551 204.474C109.519 204.572 109.466 204.662 109.398 204.739C109.329 204.816 109.245 204.878 109.151 204.92C109.057 204.963 108.955 204.985 108.852 204.986Z",
    fill: "white"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M430.5 386.859H139.092L121.332 176.715H412.74L430.5 386.859Z",
    fill: "white"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M316.236 227.391L321.696 291.963H422.484L424.608 317.103H363.648L369.552 386.859H358.152L352.248 317.103H266.796L272.7 386.859H247.164L241.26 317.103H179.928L183.264 356.595L172.308 361.743L138.312 377.703L137.268 365.355L171.264 349.395L168.528 317.103H133.188L131.064 291.963H239.136L235.068 243.747L121.8 182.319L121.332 176.727H134.256L233.964 230.799L229.404 176.727H254.94L264.672 291.963H310.296L300.564 176.727H311.964L315.288 216.159H416.076L417.024 227.391H316.236Z",
    fill: "black"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M191.688 285.912H233.148L230.844 258.66H189.384L191.688 285.912Z",
    fill: "white"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M186.648 268.395H168.852L170.328 285.915H188.136L186.648 268.395Z",
    fill: "white"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M148.968 285.915H166.764L165.288 268.395H147.492L148.968 285.915Z",
    fill: "white"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M157.116 207.866L136.392 196.73L131.856 205.85L152.568 216.998L157.116 207.866Z",
    fill: "white"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M175.848 229.514L180.384 220.394L159.672 209.246L155.124 218.366L175.848 229.514Z",
    fill: "white"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M199.116 242.041L203.652 232.909L182.94 221.773L178.404 230.893L199.116 242.041Z",
    fill: "white"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M147.72 228.288H142.02C140.971 228.261 139.928 228.457 138.961 228.863C137.993 229.27 137.123 229.877 136.409 230.645C135.694 231.413 135.15 232.325 134.814 233.319C134.479 234.313 134.358 235.367 134.46 236.412L135.84 252.768C136.078 254.98 137.12 257.028 138.768 258.523C140.416 260.019 142.555 260.857 144.78 260.88H150.468C151.516 260.906 152.559 260.71 153.526 260.305C154.493 259.899 155.363 259.293 156.078 258.526C156.794 257.76 157.339 256.85 157.677 255.857C158.015 254.865 158.139 253.812 158.04 252.768L156.648 236.4C156.413 234.188 155.374 232.14 153.728 230.645C152.082 229.149 149.944 228.31 147.72 228.288Z",
    fill: "white"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M301.104 258.66H267.876L270.036 284.208H303.264L301.104 258.66Z",
    fill: "white"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M279.396 248.845H300.276L298.536 228.289H277.656L279.396 248.845Z",
    fill: "white"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M284.904 199.129H262.848L264.684 220.849H286.74L284.904 199.129Z",
    fill: "white"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M341.268 188.27H319.212L321.048 209.99H343.116L341.268 188.27Z",
    fill: "white"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M327.324 284.209H355.488L354.48 272.293H326.316L327.324 284.209Z",
    fill: "white"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M359.916 284.209H388.08L387.072 272.293H358.908L359.916 284.209Z",
    fill: "white"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M392.52 284.209H413.088L412.08 272.293H391.512L392.52 284.209Z",
    fill: "white"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M321.252 339.66C318.592 339.584 315.946 340.076 313.49 341.102C311.035 342.128 308.825 343.664 307.009 345.61C305.193 347.555 303.812 349.865 302.957 352.385C302.103 354.906 301.794 357.579 302.052 360.228C302.646 365.832 305.279 371.022 309.449 374.812C313.62 378.602 319.037 380.727 324.672 380.784C327.332 380.861 329.978 380.371 332.434 379.347C334.889 378.322 337.099 376.787 338.915 374.842C340.731 372.898 342.113 370.589 342.967 368.069C343.822 365.549 344.131 362.876 343.872 360.228C343.281 354.622 340.65 349.429 336.479 345.637C332.308 341.844 326.889 339.717 321.252 339.66Z",
    fill: "white"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M404.761 261.075C409.273 255.399 407.917 246.813 401.732 241.897C395.548 236.982 386.878 237.598 382.366 243.274C377.855 248.95 379.211 257.536 385.395 262.451C391.579 267.367 400.25 266.751 404.761 261.075Z",
    fill: "white"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M298.992 323.57H273.36L274.728 339.662H300.36L298.992 323.57Z",
    fill: "white"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M376.128 363.65H390.684L387.3 323.57H372.744L376.128 363.65Z",
    fill: "white"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M394.572 323.57L395.94 339.662H421.632L420.276 323.57H394.572Z",
    fill: "white"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M147.18 339.662H163.536L162.18 323.57H145.824L147.18 339.662Z",
    fill: "white"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M193.26 346.512H219.6L217.812 325.332H191.46L193.26 346.512Z",
    fill: "white"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M191.4 380.929H239.604L238.356 366.145H190.152L191.4 380.929Z",
    fill: "white"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M196.68 198.828L223.008 212.7L221.004 189H195.84L196.68 198.828Z",
    fill: "white"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M245.232 181.67C243.201 179.783 240.518 178.757 237.746 178.806C234.974 178.856 232.329 179.979 230.367 181.937C228.405 183.896 227.279 186.539 227.225 189.311C227.17 192.083 228.192 194.768 230.076 196.802L237.648 204.374L245.232 196.802C247.235 194.793 248.359 192.072 248.359 189.236C248.359 186.399 247.235 183.678 245.232 181.67ZM240.6 192.194C240.016 192.778 239.272 193.176 238.462 193.337C237.652 193.499 236.812 193.416 236.049 193.1C235.286 192.784 234.633 192.249 234.174 191.562C233.715 190.875 233.47 190.068 233.47 189.242C233.47 188.416 233.715 187.608 234.174 186.921C234.633 186.235 235.286 185.699 236.049 185.383C236.812 185.067 237.652 184.985 238.462 185.146C239.272 185.307 240.016 185.705 240.6 186.29C240.989 186.677 241.298 187.137 241.508 187.643C241.719 188.15 241.827 188.693 241.827 189.242C241.827 189.79 241.719 190.334 241.508 190.84C241.298 191.347 240.989 191.807 240.6 192.194Z",
    fill: "#263238"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M245.232 196.801L237.6 204.397V193.417C238.714 193.417 239.782 192.974 240.57 192.187C241.358 191.399 241.8 190.331 241.8 189.217C241.8 188.103 241.358 187.035 240.57 186.247C239.782 185.459 238.714 185.017 237.6 185.017V178.477C239.728 178.466 241.811 179.087 243.585 180.263C245.358 181.439 246.742 183.116 247.56 185.08C248.378 187.044 248.594 189.207 248.179 191.294C247.765 193.381 246.739 195.298 245.232 196.801Z",
    fill: "white"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M386.208 254.701C385.213 253.706 384.031 252.917 382.731 252.378C381.431 251.84 380.037 251.562 378.63 251.562C377.223 251.563 375.829 251.84 374.529 252.378C373.229 252.917 372.047 253.706 371.052 254.701C370.057 255.697 369.267 256.878 368.729 258.178C368.19 259.478 367.913 260.872 367.913 262.279C367.913 263.687 368.19 265.08 368.729 266.381C369.267 267.681 370.057 268.862 371.052 269.857L378.624 277.429L386.208 269.857C387.203 268.862 387.993 267.681 388.531 266.381C389.07 265.08 389.347 263.687 389.347 262.279C389.347 260.872 389.07 259.478 388.531 258.178C387.993 256.878 387.203 255.697 386.208 254.701ZM381.6 265.201C381.016 265.786 380.272 266.184 379.462 266.345C378.652 266.506 377.812 266.424 377.049 266.108C376.286 265.792 375.633 265.257 375.174 264.57C374.715 263.883 374.47 263.075 374.47 262.249C374.47 261.423 374.715 260.616 375.174 259.929C375.633 259.242 376.286 258.707 377.049 258.391C377.812 258.075 378.652 257.992 379.462 258.154C380.272 258.315 381.016 258.713 381.6 259.297C381.989 259.684 382.298 260.144 382.508 260.651C382.719 261.158 382.827 261.701 382.827 262.249C382.827 262.798 382.719 263.341 382.508 263.848C382.298 264.354 381.989 264.814 381.6 265.201Z",
    fill: "#263238"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M386.208 269.857L378.624 277.429V266.401C379.738 266.401 380.806 265.958 381.594 265.171C382.382 264.383 382.824 263.315 382.824 262.201C382.824 261.087 382.382 260.019 381.594 259.231C380.806 258.443 379.738 258.001 378.624 258.001V251.461C380.743 251.464 382.813 252.094 384.574 253.273C386.335 254.451 387.708 256.124 388.519 258.082C389.33 260.039 389.544 262.193 389.132 264.271C388.721 266.35 387.704 268.26 386.208 269.761V269.857Z",
    fill: "white"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M241.848 353.401C239.838 351.391 237.112 350.262 234.27 350.262C231.428 350.262 228.702 351.391 226.692 353.401C224.682 355.41 223.553 358.136 223.553 360.979C223.553 363.821 224.682 366.547 226.692 368.557L234.264 376.129L241.848 368.557C242.843 367.562 243.633 366.38 244.172 365.08C244.71 363.78 244.987 362.386 244.987 360.979C244.987 359.571 244.71 358.178 244.172 356.877C243.633 355.577 242.843 354.396 241.848 353.401ZM237.216 363.925C236.632 364.509 235.888 364.907 235.078 365.068C234.268 365.23 233.428 365.147 232.665 364.831C231.902 364.515 231.249 363.98 230.79 363.293C230.331 362.606 230.086 361.799 230.086 360.973C230.086 360.147 230.331 359.339 230.79 358.652C231.249 357.966 231.902 357.43 232.665 357.114C233.428 356.798 234.268 356.716 235.078 356.877C235.888 357.038 236.632 357.436 237.216 358.021C237.605 358.408 237.914 358.868 238.124 359.374C238.335 359.881 238.443 360.424 238.443 360.973C238.443 361.521 238.335 362.064 238.124 362.571C237.914 363.078 237.605 363.538 237.216 363.925Z",
    fill: "#263238"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M241.848 368.559L234.264 376.131V365.151C235.378 365.151 236.446 364.708 237.234 363.921C238.022 363.133 238.464 362.065 238.464 360.951C238.464 359.837 238.022 358.769 237.234 357.981C236.446 357.193 235.378 356.751 234.264 356.751V350.211C236.383 350.214 238.453 350.844 240.214 352.023C241.975 353.201 243.348 354.874 244.159 356.832C244.97 358.789 245.184 360.943 244.772 363.021C244.361 365.1 243.344 367.01 241.848 368.511V368.559Z",
    fill: "white"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M398.328 187.203H273.312C271.532 187.207 269.826 187.916 268.568 189.176C267.31 190.436 266.604 192.143 266.604 193.923V239.115C266.604 240.894 267.311 242.601 268.569 243.859C269.827 245.117 271.533 245.823 273.312 245.823H364.692L376.8 255.195L373.2 245.787H398.4C400.179 245.787 401.885 245.081 403.143 243.823C404.401 242.565 405.108 240.858 405.108 239.079V193.887C405.103 193.003 404.924 192.128 404.58 191.313C404.237 190.498 403.736 189.759 403.106 189.138C402.476 188.517 401.73 188.026 400.91 187.694C400.09 187.362 399.213 187.195 398.328 187.203Z",
    fill: "black"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M401.928 183.602H276.912C275.132 183.605 273.426 184.314 272.168 185.574C270.91 186.834 270.204 188.542 270.204 190.322V235.514C270.204 237.293 270.911 238.999 272.169 240.257C273.427 241.515 275.133 242.222 276.912 242.222H368.292L376.8 255.194V242.186H402C403.779 242.186 405.485 241.479 406.743 240.221C408.001 238.963 408.708 237.257 408.708 235.478V190.286C408.703 189.401 408.524 188.526 408.181 187.711C407.837 186.896 407.336 186.157 406.706 185.536C406.076 184.915 405.33 184.425 404.51 184.093C403.69 183.761 402.813 183.594 401.928 183.602Z",
    fill: "#4A1FB8"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M319.932 196.263V229.503C319.935 230.02 319.816 230.53 319.584 230.991C319.589 231.027 319.589 231.064 319.584 231.099C319.517 231.225 319.441 231.345 319.356 231.459C319.044 231.898 318.633 232.255 318.156 232.503C317.802 232.695 317.415 232.821 317.016 232.875C316.905 232.888 316.792 232.888 316.68 232.875H283.08C282.853 232.865 282.627 232.829 282.408 232.767H282.312C282.07 232.688 281.836 232.584 281.616 232.455C281.463 232.374 281.319 232.277 281.184 232.167C280.902 231.949 280.659 231.686 280.464 231.387C280.134 230.895 279.944 230.323 279.912 229.731C279.906 229.656 279.906 229.579 279.912 229.503V196.263C279.912 195.378 280.256 194.527 280.872 193.891C281.488 193.255 282.327 192.884 283.212 192.855H316.548C317.448 192.862 318.309 193.224 318.943 193.862C319.576 194.501 319.932 195.364 319.932 196.263Z",
    fill: "white"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M391.416 207.073H334.872C334.676 207.073 334.483 207.035 334.302 206.96C334.122 206.885 333.958 206.776 333.82 206.638C333.681 206.499 333.572 206.335 333.497 206.155C333.422 205.974 333.384 205.781 333.384 205.585C333.387 205.193 333.545 204.817 333.824 204.541C334.103 204.264 334.479 204.109 334.872 204.109H391.416C391.807 204.109 392.183 204.265 392.459 204.542C392.736 204.818 392.892 205.194 392.892 205.585C392.893 205.78 392.856 205.973 392.783 206.154C392.709 206.334 392.601 206.499 392.464 206.637C392.326 206.775 392.163 206.885 391.983 206.96C391.804 207.035 391.611 207.073 391.416 207.073Z",
    fill: "white"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M373.26 192.854H335.496C335.206 192.832 334.915 192.87 334.64 192.966C334.366 193.062 334.114 193.213 333.901 193.411C333.688 193.609 333.518 193.848 333.401 194.115C333.285 194.381 333.225 194.669 333.225 194.96C333.225 195.25 333.285 195.538 333.401 195.805C333.518 196.071 333.688 196.311 333.901 196.508C334.114 196.706 334.366 196.858 334.64 196.953C334.915 197.049 335.206 197.088 335.496 197.066H373.26C373.791 197.026 374.288 196.786 374.65 196.396C375.012 196.005 375.213 195.492 375.213 194.96C375.213 194.427 375.012 193.914 374.65 193.524C374.288 193.133 373.791 192.894 373.26 192.854Z",
    fill: "white"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M368.616 213.171H334.872C334.478 213.168 334.101 213.01 333.823 212.732C333.545 212.454 333.387 212.077 333.384 211.683C333.387 211.29 333.545 210.913 333.823 210.635C334.101 210.356 334.478 210.198 334.872 210.195H368.616C369.008 210.198 369.384 210.357 369.66 210.635C369.937 210.914 370.092 211.291 370.092 211.683C370.092 212.076 369.937 212.453 369.66 212.731C369.384 213.01 369.008 213.168 368.616 213.171Z",
    fill: "white"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M294.12 193.572C296.104 191.837 298.492 190.629 301.066 190.06C303.639 189.492 306.314 189.581 308.844 190.32C317.376 192.972 313.644 208.848 313.644 208.848C315.071 210.458 316.026 212.429 316.405 214.546C316.783 216.663 316.572 218.844 315.792 220.848C313.128 227.892 292.752 229.452 285.852 223.368C278.952 217.284 286.98 202.008 290.928 200.232C294.876 198.456 294.12 193.572 294.12 193.572Z",
    fill: "#263238"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M318.132 232.502C317.777 232.694 317.391 232.82 316.992 232.874C316.88 232.887 316.768 232.887 316.656 232.874H283.056C282.829 232.864 282.603 232.828 282.384 232.766H282.288C282.046 232.687 281.812 232.583 281.592 232.454C281.439 232.373 281.294 232.276 281.16 232.166C280.878 231.948 280.635 231.685 280.44 231.386C280.332 230.858 280.224 230.306 280.104 229.754C282.504 229.346 284.808 229.022 287.184 228.806C288.936 228.638 290.7 228.53 292.476 228.47C293.328 228.47 294.192 228.47 295.044 228.398C297.948 228.398 300.864 228.398 303.756 228.686L305.616 228.854C308.34 229.19 311.22 229.718 313.476 230.174C315.732 230.63 317.604 231.062 317.604 231.062C317.604 231.062 317.928 231.182 318.132 232.502Z",
    fill: "#4A1FB8"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M318.132 232.502C317.777 232.694 317.391 232.82 316.992 232.874C316.88 232.887 316.768 232.887 316.656 232.874H283.056C282.829 232.864 282.603 232.828 282.384 232.766H282.288C282.046 232.687 281.812 232.583 281.592 232.454C281.439 232.373 281.294 232.276 281.16 232.166C280.878 231.948 280.635 231.685 280.44 231.386C280.332 230.858 280.224 230.306 280.104 229.754C282.504 229.346 284.808 229.022 287.184 228.806C288.936 228.638 290.7 228.53 292.476 228.47C293.328 228.47 294.192 228.47 295.044 228.398C297.948 228.398 300.864 228.398 303.756 228.686L305.616 228.854C308.34 229.19 311.22 229.718 313.476 230.174C315.732 230.63 317.604 231.062 317.604 231.062C317.604 231.062 317.928 231.182 318.132 232.502Z",
    fill: "black"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M304.8 232.911H297.384C295.927 232.178 294.686 231.078 293.784 229.719C294.306 229.348 294.771 228.904 295.164 228.399C295.522 227.96 295.82 227.476 296.052 226.959C296.934 224.7 297.106 222.226 296.544 219.867C296.364 218.967 296.16 218.343 296.124 218.211L304.524 220.959C304.356 221.523 304.224 222.051 304.104 222.543C303.924 223.275 303.804 223.935 303.708 224.523C303.58 225.316 303.536 226.121 303.576 226.923C303.589 227.525 303.715 228.119 303.948 228.675C304.452 229.875 305.292 230.031 305.292 230.031C305.46 230.513 305.503 231.031 305.417 231.534C305.331 232.038 305.119 232.512 304.8 232.911Z",
    fill: "#E4897B"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M304.344 220.923C303.993 222.104 303.721 223.306 303.528 224.523C299.532 223.011 296.004 218.211 296.004 218.211L304.344 220.923Z",
    fill: "black"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M299.904 196.202C307.38 195.458 310.2 199.226 311.508 206.882C313.152 216.482 311.7 223.514 302.136 222.386C289.2 220.802 287.472 197.438 299.904 196.202Z",
    fill: "#E4897B"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M306.624 206.941C307.335 208.003 308.174 208.974 309.12 209.833C308.931 210.165 308.653 210.438 308.319 210.622C307.984 210.806 307.605 210.895 307.224 210.877L306.624 206.941Z",
    fill: "#DE5753"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M301.98 206.786C302.064 207.398 301.788 207.986 301.38 207.986C300.972 207.986 300.576 207.578 300.504 206.966C300.432 206.354 300.696 205.766 301.104 205.766C301.512 205.766 301.908 206.174 301.98 206.786Z",
    fill: "#263238"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M300.936 205.813L302.208 205.129C302.208 205.129 301.68 206.329 300.936 205.813Z",
    fill: "#263238"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M309.6 205.719C309.672 206.331 309.408 206.919 308.988 206.919C308.568 206.919 308.196 206.523 308.112 205.899C308.028 205.275 308.316 204.699 308.724 204.699C309.132 204.699 309.516 205.107 309.6 205.719Z",
    fill: "#263238"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M308.556 204.759L309.828 204.062C309.828 204.062 309.3 205.275 308.556 204.759Z",
    fill: "#263238"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M298.26 203.509C298.175 203.509 298.091 203.484 298.02 203.437C297.927 203.371 297.863 203.273 297.84 203.161C297.818 203.049 297.839 202.933 297.9 202.837C298.315 202.309 298.849 201.885 299.457 201.599C300.065 201.314 300.732 201.175 301.404 201.193C301.52 201.196 301.63 201.244 301.71 201.327C301.791 201.41 301.836 201.521 301.836 201.637C301.822 201.75 301.768 201.854 301.685 201.93C301.601 202.007 301.493 202.052 301.38 202.057C300.855 202.048 300.335 202.156 299.857 202.374C299.38 202.592 298.957 202.914 298.62 203.317C298.582 203.378 298.529 203.428 298.466 203.461C298.403 203.495 298.332 203.511 298.26 203.509Z",
    fill: "#263238"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M309.852 201.517C309.785 201.534 309.715 201.534 309.648 201.517C309.258 201.268 308.817 201.111 308.358 201.057C307.898 201.003 307.433 201.054 306.996 201.205C306.892 201.255 306.773 201.263 306.664 201.226C306.555 201.189 306.465 201.11 306.414 201.007C306.363 200.903 306.355 200.784 306.392 200.675C306.429 200.565 306.508 200.475 306.612 200.425C307.172 200.211 307.774 200.129 308.372 200.185C308.969 200.241 309.545 200.434 310.056 200.749C310.107 200.775 310.151 200.811 310.188 200.855C310.225 200.899 310.252 200.95 310.269 201.005C310.286 201.06 310.291 201.117 310.286 201.174C310.28 201.231 310.263 201.286 310.236 201.337C310.192 201.396 310.134 201.444 310.067 201.475C310 201.507 309.926 201.521 309.852 201.517Z",
    fill: "#263238"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M306.432 213.928C306.159 214.807 305.95 215.706 305.808 216.616C305.652 216.616 305.484 216.616 305.328 216.616C303.12 216.616 302.1 215.884 301.644 215.08C301.425 214.682 301.305 214.237 301.296 213.784C301.26 213.529 301.26 213.27 301.296 213.016C302.655 213.62 304.128 213.927 305.616 213.916C306.132 213.94 306.432 213.928 306.432 213.928Z",
    fill: "#263238"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M305.676 213.916L305.472 214.708C303.408 214.708 301.944 214.408 301.296 213.784C301.26 213.529 301.26 213.27 301.296 213.016C302.674 213.629 304.168 213.936 305.676 213.916Z",
    fill: "white"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M305.328 216.614C303.12 216.614 302.1 215.882 301.644 215.078C302.466 215.105 303.278 215.272 304.044 215.57C304.573 215.771 305.024 216.137 305.328 216.614Z",
    fill: "#DE5753"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M292.968 209.631C292.968 209.631 295.86 203.127 294.864 198.435C294.864 198.435 309.096 190.899 311.316 205.887C311.316 205.887 311.436 192.375 298.548 193.347C285.66 194.319 287.568 213.159 294.78 218.103C294.78 218.103 291.192 213.687 292.968 209.631Z",
    fill: "#263238"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M294.348 211.081C294.27 210.656 294.109 210.251 293.875 209.888C293.64 209.526 293.336 209.213 292.981 208.968C292.625 208.723 292.225 208.55 291.803 208.46C291.381 208.369 290.945 208.363 290.52 208.441C288.228 208.921 287.592 213.793 293.472 214.369C294.324 214.441 294.708 213.601 294.348 211.081Z",
    fill: "#E4897B"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M318.132 232.502C317.777 232.694 317.391 232.82 316.992 232.874C316.88 232.887 316.768 232.887 316.656 232.874H283.056C282.829 232.864 282.603 232.828 282.384 232.766H282.288C282.046 232.687 281.812 232.583 281.592 232.454C281.439 232.373 281.294 232.276 281.16 232.166C280.878 231.948 280.635 231.685 280.44 231.386C280.332 230.858 280.224 230.306 280.104 229.754C282.504 229.346 284.808 229.022 287.184 228.806C288.936 228.638 290.7 228.53 292.476 228.47C293.328 228.47 294.192 228.47 295.044 228.398C297.948 228.398 300.864 228.398 303.756 228.686L305.616 228.854C308.34 229.19 311.22 229.718 313.476 230.174C315.732 230.63 317.604 231.062 317.604 231.062C317.604 231.062 317.928 231.182 318.132 232.502Z",
    fill: "#E4897B"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M289.044 232.911H283.044C282.817 232.901 282.591 232.865 282.372 232.803H282.276C282.034 232.724 281.8 232.62 281.58 232.491C281.427 232.41 281.282 232.313 281.148 232.203C280.866 231.985 280.623 231.722 280.428 231.423C280.098 230.931 279.907 230.359 279.876 229.767L286.548 227.691C286.548 227.691 286.788 228.099 287.172 228.891C287.556 229.683 288.336 231.147 289.044 232.911Z",
    fill: "white"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M319.584 230.99C319.588 231.026 319.588 231.062 319.584 231.098C319.517 231.223 319.44 231.344 319.356 231.458C319.044 231.896 318.633 232.254 318.156 232.502C317.801 232.694 317.415 232.82 317.016 232.874C316.904 232.887 316.792 232.887 316.68 232.874H311.244C311.04 230.99 310.836 228.578 310.836 228.578L319.584 230.99Z",
    fill: "white"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M299.904 196.203C299.904 196.203 301.356 205.695 292.62 208.731C282.072 212.403 281.556 223.347 291.012 226.011C291.012 226.011 281.412 223.731 280.368 217.107C279.324 210.483 286.02 201.435 286.02 201.435C286.02 201.435 283.776 195.663 292.332 192.507C297.156 190.731 299.904 196.203 299.904 196.203Z",
    fill: "#263238"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M298.8 205.106C298.753 205.116 298.703 205.116 298.656 205.106C298.588 205.065 298.538 205.001 298.516 204.925C298.493 204.849 298.501 204.768 298.536 204.698C302.076 198.362 299.076 195.362 298.944 195.23C298.889 195.173 298.858 195.098 298.858 195.02C298.858 194.941 298.889 194.866 298.944 194.81C299.002 194.754 299.079 194.723 299.16 194.723C299.24 194.723 299.318 194.754 299.376 194.81C299.52 194.954 302.856 198.23 299.076 204.998C299.042 205.037 299 205.068 298.952 205.086C298.903 205.105 298.851 205.112 298.8 205.106Z",
    fill: "#263238"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M314.472 224.077C314.431 224.076 314.391 224.068 314.354 224.051C314.317 224.035 314.283 224.011 314.256 223.981C314.227 223.954 314.204 223.922 314.189 223.885C314.173 223.849 314.165 223.81 314.165 223.771C314.165 223.732 314.173 223.693 314.189 223.657C314.204 223.621 314.227 223.588 314.256 223.561C315.206 222.73 315.966 221.704 316.483 220.552C317.001 219.401 317.265 218.151 317.256 216.889C317.1 212.185 312.756 208.405 312.72 208.369C312.691 208.342 312.668 208.31 312.653 208.273C312.637 208.237 312.629 208.198 312.629 208.159C312.629 208.12 312.637 208.081 312.653 208.045C312.668 208.009 312.691 207.976 312.72 207.949C312.776 207.894 312.851 207.863 312.93 207.863C313.008 207.863 313.084 207.894 313.14 207.949C313.332 208.117 317.724 211.933 317.94 216.901C317.952 218.248 317.675 219.581 317.126 220.811C316.577 222.041 315.77 223.139 314.76 224.029C314.721 224.063 314.674 224.086 314.623 224.094C314.572 224.103 314.52 224.097 314.472 224.077Z",
    fill: "#263238"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M285.3 103.863H160.284C158.504 103.866 156.798 104.576 155.54 105.836C154.283 107.096 153.576 108.803 153.576 110.583V155.775C153.576 157.555 154.283 159.263 155.54 160.523C156.798 161.783 158.504 162.492 160.284 162.495H223.668L234 181.515L231.924 162.495H285.252C287.034 162.495 288.744 161.787 290.004 160.527C291.264 159.267 291.972 157.558 291.972 155.775V110.583C291.972 108.809 291.271 107.107 290.021 105.848C288.771 104.59 287.074 103.876 285.3 103.863Z",
    fill: "black"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M288.9 100.262H163.884C162.104 100.265 160.398 100.974 159.14 102.234C157.883 103.494 157.176 105.202 157.176 106.982V152.174C157.176 153.954 157.883 155.661 159.14 156.921C160.398 158.181 162.104 158.891 163.884 158.894H227.268L234 181.514L235.524 158.894H288.852C290.635 158.894 292.344 158.186 293.604 156.925C294.864 155.665 295.572 153.956 295.572 152.174V106.982C295.572 105.208 294.871 103.506 293.621 102.247C292.371 100.988 290.674 100.274 288.9 100.262Z",
    fill: "#4A1FB8"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M206.916 112.959V146.199C206.923 146.243 206.923 146.287 206.916 146.331C206.901 146.842 206.77 147.342 206.532 147.795C206.465 147.92 206.389 148.04 206.304 148.155C205.884 148.76 205.277 149.211 204.576 149.439C204.385 149.501 204.188 149.545 203.988 149.571C203.877 149.583 203.764 149.583 203.652 149.571H170.052C169.825 149.56 169.599 149.524 169.38 149.463H169.284C169.042 149.384 168.808 149.279 168.588 149.151C168.435 149.069 168.291 148.972 168.156 148.863C167.941 148.695 167.747 148.502 167.58 148.287C167.467 148.142 167.37 147.985 167.292 147.819C167.012 147.325 166.867 146.766 166.872 146.199V112.959C166.872 112.073 167.216 111.222 167.832 110.586C168.448 109.95 169.287 109.579 170.172 109.551H203.508C203.956 109.551 204.399 109.639 204.812 109.81C205.226 109.981 205.602 110.233 205.918 110.549C206.234 110.865 206.486 111.241 206.657 111.655C206.828 112.068 206.916 112.511 206.916 112.959Z",
    fill: "white"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M278.4 123.769H221.844C221.451 123.769 221.075 123.614 220.796 123.337C220.517 123.061 220.359 122.685 220.356 122.293C220.356 121.898 220.513 121.52 220.792 121.241C221.071 120.961 221.449 120.805 221.844 120.805H278.4C278.795 120.805 279.173 120.961 279.452 121.241C279.731 121.52 279.888 121.898 279.888 122.293C279.885 122.685 279.727 123.061 279.448 123.337C279.169 123.614 278.793 123.769 278.4 123.769Z",
    fill: "white"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M260.232 109.549H222.468C222.178 109.527 221.887 109.565 221.613 109.661C221.338 109.757 221.086 109.909 220.873 110.106C220.66 110.304 220.49 110.544 220.374 110.81C220.257 111.077 220.197 111.364 220.197 111.655C220.197 111.946 220.257 112.233 220.374 112.5C220.49 112.766 220.66 113.006 220.873 113.204C221.086 113.401 221.338 113.553 221.613 113.649C221.887 113.745 222.178 113.783 222.468 113.761H260.232C260.522 113.783 260.814 113.745 261.088 113.649C261.363 113.553 261.614 113.401 261.827 113.204C262.041 113.006 262.211 112.766 262.327 112.5C262.443 112.233 262.503 111.946 262.503 111.655C262.503 111.364 262.443 111.077 262.327 110.81C262.211 110.544 262.041 110.304 261.827 110.106C261.614 109.909 261.363 109.757 261.088 109.661C260.814 109.565 260.522 109.527 260.232 109.549Z",
    fill: "white"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M255.6 129.867H221.844C221.45 129.863 221.074 129.706 220.795 129.427C220.517 129.149 220.359 128.772 220.356 128.379C220.359 127.985 220.517 127.608 220.795 127.33C221.074 127.052 221.45 126.894 221.844 126.891H255.6C255.994 126.894 256.37 127.052 256.649 127.33C256.927 127.608 257.085 127.985 257.088 128.379C257.085 128.772 256.927 129.149 256.649 129.427C256.37 129.706 255.994 129.863 255.6 129.867Z",
    fill: "white"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M200.4 149.608H177.36C177.3 149.049 177.3 148.486 177.36 147.928C177.36 147.76 177.36 147.604 177.36 147.46C177.38 147.326 177.408 147.194 177.444 147.064C177.529 146.457 177.752 145.878 178.095 145.37C178.438 144.863 178.893 144.44 179.424 144.136C179.88 144.028 180.432 143.92 181.056 143.8L182.136 143.62L183.228 143.452C185.568 143.106 187.931 142.945 190.296 142.972C191.05 142.982 191.803 143.03 192.552 143.116C192.77 143.135 192.986 143.167 193.2 143.212C194.415 143.352 195.584 143.762 196.62 144.412C197.37 144.968 198.026 145.641 198.564 146.404C198.877 146.831 199.165 147.276 199.428 147.736C199.796 148.336 200.12 148.962 200.4 149.608Z",
    fill: "#263238"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M206.904 146.329C206.889 146.84 206.758 147.341 206.52 147.793C206.453 147.919 206.377 148.039 206.292 148.153C205.872 148.759 205.265 149.21 204.564 149.437C204.373 149.5 204.176 149.544 203.976 149.569C203.865 149.582 203.752 149.582 203.64 149.569H170.04C169.813 149.559 169.588 149.522 169.368 149.461H169.272C169.03 149.382 168.797 149.278 168.576 149.149C168.423 149.067 168.279 148.971 168.144 148.861C167.929 148.694 167.736 148.5 167.568 148.285C169.068 148.141 171.168 147.949 173.712 147.745L176.112 147.553L176.988 147.481H177.372L179.904 147.301C180.084 147.301 180.276 147.301 180.48 147.301C182.88 147.121 185.568 146.965 188.316 146.821L192.708 146.629L195.792 146.521H196.716H197.628H198.6H198.972H200.412C202.632 146.317 204.78 146.305 206.904 146.329Z",
    fill: "#263238"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M206.904 146.329C206.889 146.84 206.758 147.341 206.52 147.793C206.453 147.919 206.377 148.039 206.292 148.153C205.872 148.759 205.265 149.21 204.564 149.437C204.373 149.5 204.176 149.544 203.976 149.569C203.865 149.582 203.752 149.582 203.64 149.569H170.04C169.813 149.559 169.588 149.522 169.368 149.461H169.272C169.03 149.382 168.797 149.278 168.576 149.149C168.423 149.067 168.279 148.971 168.144 148.861C167.929 148.694 167.736 148.5 167.568 148.285C169.068 148.141 171.168 147.949 173.712 147.745L176.112 147.553L176.988 147.481H177.372L179.904 147.301C180.084 147.301 180.276 147.301 180.48 147.301C182.88 147.121 185.568 146.965 188.316 146.821L192.708 146.629L195.792 146.521H196.716H197.628H198.6H198.972H200.412C202.632 146.317 204.78 146.305 206.904 146.329Z",
    fill: "white"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M195.096 149.607H185.832L185.424 149.523C183.629 149.188 181.949 148.403 180.54 147.243L180.252 146.967C181.181 146.035 181.858 144.883 182.22 143.619C182.292 143.379 182.376 143.127 182.436 142.875C182.849 141.226 183.071 139.534 183.096 137.835C183.102 137.739 183.102 137.642 183.096 137.547C183.126 136.041 183.078 134.535 182.952 133.035C182.832 131.703 182.688 130.431 182.508 129.255C182.4 128.535 182.292 127.851 182.172 127.227L183.216 128.139L183.312 128.211L187.464 131.811L188.664 132.843L192.888 136.515C192.714 137.159 192.573 137.812 192.468 138.471V138.651C192.271 139.744 192.247 140.862 192.396 141.963C192.42 142.157 192.456 142.349 192.504 142.539C192.551 142.738 192.611 142.935 192.684 143.127C192.679 143.17 192.679 143.215 192.684 143.259C192.903 143.826 193.215 144.354 193.608 144.819C194.231 145.527 195.001 146.092 195.864 146.475C196.488 146.762 197.14 146.987 197.808 147.147C198.42 148.263 196.656 149.103 195.096 149.607Z",
    fill: "#E4897B"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M184.38 132.746C184.284 139.598 189.744 141.926 192.456 142.526C192.197 141.243 192.197 139.921 192.456 138.638L184.38 132.746Z",
    fill: "black"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M198.564 149.606H179.772L177.372 147.926L176.916 147.602L177.048 147.482L177.516 147.062L179.484 145.286L181.128 143.798L182.268 142.766L182.436 142.874L183.312 143.45L188.4 146.762L191.82 149.006L192.792 146.606L193.512 144.782H193.62L196.8 146.402L197.124 146.57C197.385 146.704 197.62 146.883 197.82 147.098C198.029 147.318 198.195 147.574 198.312 147.854C198.345 147.924 198.373 147.996 198.396 148.07C198.578 148.56 198.636 149.088 198.564 149.606Z",
    fill: "white"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M199.572 111.23C202.98 113.21 203.736 121.526 199.032 126.986C194.328 132.446 189.624 112.586 189.624 112.586C189.624 112.586 197.4 109.97 199.572 111.23Z",
    fill: "#263238"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M184.584 139.394C186.191 140.86 188.231 141.762 190.397 141.963C192.563 142.165 194.735 141.654 196.584 140.51C199.005 139.055 200.781 136.734 201.552 134.018C201.66 133.646 201.744 133.262 201.828 132.818C203.028 125.618 201.24 113.99 193.32 111.338C191.573 110.741 189.701 110.602 187.885 110.934C186.068 111.267 184.367 112.06 182.944 113.237C181.522 114.414 180.424 115.937 179.758 117.659C179.091 119.381 178.877 121.245 179.136 123.074C180.144 130.97 180.336 135.602 184.584 139.394Z",
    fill: "#E4897B"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M191.28 124.572C191.28 125.208 191.688 125.772 192.108 125.676C192.528 125.58 192.828 125.112 192.792 124.476C192.756 123.84 192.372 123.348 191.964 123.372C191.556 123.396 191.244 123.924 191.28 124.572Z",
    fill: "#263238"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M198.528 124.107C198.528 124.755 198.948 125.307 199.368 125.223C199.788 125.139 200.088 124.647 200.052 124.023C200.016 123.399 199.632 122.823 199.212 122.907C198.792 122.991 198.492 123.507 198.528 124.107Z",
    fill: "#263238"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M196.248 124.574C197.134 126.487 198.281 128.268 199.656 129.866C199.235 130.209 198.744 130.455 198.217 130.588C197.691 130.721 197.141 130.736 196.608 130.634L196.248 124.574Z",
    fill: "#DE5753"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M201.012 120.84C200.954 120.875 200.888 120.894 200.82 120.894C200.752 120.894 200.686 120.875 200.628 120.84C200.216 120.608 199.755 120.474 199.283 120.449C198.81 120.424 198.338 120.509 197.904 120.696C197.861 120.725 197.813 120.745 197.762 120.754C197.712 120.763 197.659 120.761 197.609 120.749C197.559 120.737 197.512 120.715 197.471 120.684C197.43 120.653 197.396 120.613 197.371 120.568C197.346 120.523 197.331 120.474 197.326 120.422C197.321 120.371 197.327 120.319 197.343 120.27C197.359 120.221 197.386 120.176 197.42 120.138C197.455 120.1 197.497 120.069 197.544 120.048C198.086 119.799 198.681 119.681 199.277 119.706C199.874 119.731 200.456 119.898 200.976 120.192C201.02 120.214 201.06 120.244 201.093 120.282C201.125 120.319 201.15 120.362 201.166 120.409C201.181 120.456 201.188 120.506 201.184 120.555C201.18 120.604 201.167 120.652 201.144 120.696C201.107 120.75 201.063 120.799 201.012 120.84Z",
    fill: "#263238"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M189.66 121.765C189.59 121.784 189.515 121.784 189.444 121.765C189.41 121.73 189.382 121.689 189.363 121.644C189.344 121.599 189.334 121.55 189.334 121.501C189.334 121.452 189.344 121.403 189.363 121.358C189.382 121.313 189.41 121.272 189.444 121.237C189.866 120.811 190.383 120.492 190.953 120.307C191.523 120.121 192.129 120.074 192.72 120.169C192.819 120.192 192.904 120.253 192.958 120.338C193.012 120.423 193.03 120.526 193.008 120.625C192.983 120.721 192.921 120.804 192.836 120.855C192.751 120.907 192.649 120.923 192.552 120.901C192.083 120.841 191.606 120.89 191.159 121.044C190.711 121.198 190.306 121.453 189.972 121.789C189.922 121.809 189.868 121.817 189.814 121.813C189.76 121.809 189.707 121.792 189.66 121.765Z",
    fill: "#263238"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M184.332 112.934L184.596 114.134C183.54 114.866 183.528 118.478 184.212 119.786C185.652 122.57 184.5 127.262 182.472 129.314C182.472 129.314 182.268 128.114 181.272 128.486C180.276 128.858 181.272 135.434 183.672 138.326C183.672 138.326 180.216 135.842 177.672 129.158C175.272 122.966 174.516 117.686 175.56 115.07L184.332 112.934Z",
    fill: "#263238"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M176.148 129.819C177.134 131.546 178.766 132.811 180.684 133.335C183.228 134.007 184.476 131.715 183.744 129.327C183.072 127.215 180.96 124.239 178.404 124.647C177.849 124.735 177.325 124.962 176.88 125.306C176.436 125.65 176.085 126.1 175.86 126.615C175.635 127.131 175.544 127.694 175.594 128.254C175.644 128.814 175.835 129.352 176.148 129.819Z",
    fill: "#E4897B"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M196.248 132.697C195.901 133.639 195.624 134.606 195.42 135.589H194.892C192.492 135.457 191.436 134.605 190.98 133.705C190.773 133.258 190.671 132.77 190.68 132.277C190.679 131.997 190.719 131.718 190.8 131.449C192.24 132.177 193.82 132.586 195.432 132.649C195.703 132.68 195.976 132.696 196.248 132.697Z",
    fill: "#263238"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M195.432 132.637L195.168 133.489C192.912 133.357 191.352 132.961 190.68 132.289C190.678 132.008 190.719 131.729 190.8 131.461C192.242 132.18 193.822 132.581 195.432 132.637Z",
    fill: "white"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M194.892 135.603C192.492 135.471 191.436 134.619 190.98 133.719C191.889 133.786 192.778 134.014 193.608 134.391C194.152 134.65 194.601 135.074 194.892 135.603Z",
    fill: "#DE5753"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M198.996 133.068C198.533 132.418 197.862 131.945 197.094 131.727C196.327 131.509 195.508 131.559 194.772 131.868C193.992 130.97 192.914 130.386 191.736 130.224C190.956 130.191 190.178 130.315 189.446 130.587C188.715 130.859 188.045 131.274 187.476 131.808C187.334 131.959 187.202 132.12 187.08 132.288C186.704 132.855 186.432 133.485 186.276 134.148C185.894 135.731 185.939 137.388 186.408 138.948C186.646 139.833 187.081 140.654 187.68 141.348C188.203 141.944 188.856 142.412 189.588 142.716C189.852 142.824 190.104 142.908 190.368 142.992C191.115 143.213 191.894 143.306 192.672 143.268C192.876 143.268 193.068 143.268 193.272 143.268C194.336 143.145 195.356 142.772 196.249 142.18C197.141 141.588 197.881 140.793 198.408 139.86C198.612 139.473 198.788 139.072 198.936 138.66C199.752 136.476 199.848 134.004 198.996 133.068ZM188.652 132.828C188.761 132.422 188.975 132.053 189.272 131.756C189.569 131.459 189.939 131.245 190.344 131.136C191.089 130.933 191.875 130.938 192.617 131.149C193.359 131.361 194.03 131.771 194.556 132.336C194.556 132.336 197.928 130.992 198.384 134.64C198.84 138.288 196.368 140.052 194.916 139.128C193.464 138.204 194.7 136.548 194.7 136.548L193.116 136.104C193.195 136.928 192.959 137.751 192.456 138.408L192.348 138.54C192.196 138.733 192.005 138.892 191.787 139.005C191.569 139.119 191.33 139.185 191.085 139.198C190.839 139.212 190.594 139.173 190.365 139.084C190.136 138.996 189.928 138.859 189.756 138.684C188.972 137.862 188.501 136.792 188.424 135.66C188.279 134.711 188.358 133.741 188.652 132.828Z",
    fill: "#263238"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M182.736 115.056C183.948 114.216 185.349 113.687 186.814 113.518C188.28 113.348 189.764 113.543 191.136 114.084C195.492 115.596 196.752 116.052 198.204 112.8C199.656 109.548 197.088 102.096 191.16 101.868C185.232 101.64 181.62 109.356 181.62 109.356C181.62 109.356 172.296 112.788 175.5 121.464L182.736 115.056Z",
    fill: "#263238"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M167.58 148.287C167.466 148.142 167.37 147.985 167.292 147.819L175.2 146.283L175.584 146.211L176.22 147.555C176.484 148.095 176.808 148.755 177.216 149.607H170.124C169.897 149.596 169.671 149.56 169.452 149.499H169.356C169.114 149.42 168.88 149.315 168.66 149.187C168.507 149.105 168.362 149.009 168.228 148.899C167.985 148.725 167.767 148.52 167.58 148.287Z",
    fill: "#263238"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M206.916 145.718V146.198C206.923 146.242 206.923 146.286 206.916 146.33C206.901 146.841 206.77 147.342 206.532 147.794C206.465 147.919 206.388 148.04 206.304 148.154C205.884 148.759 205.277 149.21 204.576 149.438C204.385 149.5 204.188 149.544 203.988 149.57C203.876 149.582 203.764 149.582 203.652 149.57H200.172C199.944 148.862 199.74 148.226 199.548 147.686C199.356 147.146 199.2 146.702 199.056 146.342C198.816 145.706 198.66 145.334 198.624 145.25L206.916 145.718Z",
    fill: "#263238"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M180.732 149.605H172.524C172.865 148.949 173.267 148.326 173.724 147.745C174.166 147.208 174.66 146.718 175.2 146.281C176.432 145.192 177.931 144.45 179.544 144.133C179.47 144.529 179.47 144.936 179.544 145.333C179.657 146.007 179.818 146.673 180.024 147.325C180.144 147.973 180.408 148.801 180.732 149.605Z",
    fill: "#263238"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M204.564 149.44C204.373 149.502 204.176 149.546 203.976 149.572C203.864 149.584 203.752 149.584 203.64 149.572H198.924C198.756 149.068 198.588 148.576 198.408 148.096C198.385 148.022 198.357 147.949 198.324 147.88C198.132 147.364 197.928 146.872 197.7 146.38C197.404 145.686 197.072 145.009 196.704 144.352C197.343 144.612 197.967 144.904 198.576 145.228C199.116 145.504 199.776 145.852 200.448 146.296C201.909 147.222 203.286 148.274 204.564 149.44Z",
    fill: "#263238"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M251.892 287.184H126.888C125.108 287.184 123.4 287.89 122.14 289.148C120.881 290.405 120.171 292.112 120.168 293.892V339.096C120.171 340.876 120.881 342.582 122.14 343.84C123.4 345.097 125.108 345.804 126.888 345.804H218.256L230.328 352.908L226.728 345.804H251.928C253.708 345.804 255.416 345.097 256.676 343.84C257.935 342.582 258.645 340.876 258.648 339.096V293.892C258.646 293.007 258.47 292.132 258.13 291.315C257.789 290.499 257.29 289.758 256.663 289.135C256.035 288.512 255.291 288.019 254.472 287.684C253.653 287.349 252.776 287.179 251.892 287.184Z",
    fill: "black"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M255.492 283.582H130.488C128.708 283.582 127 284.288 125.741 285.546C124.481 286.804 123.771 288.51 123.768 290.29V335.494C123.771 337.274 124.481 338.98 125.741 340.238C127 341.496 128.708 342.202 130.488 342.202H221.856L230.328 355.198V342.202H255.528C257.308 342.202 259.016 341.496 260.276 340.238C261.535 338.98 262.245 337.274 262.248 335.494V290.29C262.246 289.406 262.07 288.53 261.73 287.714C261.389 286.898 260.891 286.157 260.263 285.533C259.635 284.91 258.891 284.417 258.072 284.082C257.253 283.747 256.377 283.577 255.492 283.582Z",
    fill: "#4A1FB8"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M173.496 296.279V329.519C173.496 330.075 173.36 330.623 173.1 331.115C173.033 331.24 172.956 331.361 172.872 331.475C172.605 331.858 172.261 332.182 171.862 332.426C171.464 332.669 171.019 332.828 170.556 332.891C170.444 332.904 170.332 332.904 170.22 332.891H136.62C136.393 332.881 136.167 332.844 135.948 332.783H135.852C135.61 332.704 135.376 332.599 135.156 332.471C135.003 332.389 134.858 332.293 134.724 332.183C134.322 331.866 133.997 331.461 133.774 330.999C133.552 330.538 133.438 330.032 133.44 329.519V296.279C133.44 295.394 133.784 294.543 134.4 293.907C135.016 293.271 135.855 292.899 136.74 292.871H170.076C170.525 292.87 170.969 292.957 171.384 293.127C171.799 293.298 172.176 293.548 172.494 293.865C172.811 294.182 173.063 294.558 173.235 294.972C173.407 295.386 173.496 295.831 173.496 296.279Z",
    fill: "white"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M170.556 332.891C170.444 332.903 170.332 332.903 170.22 332.891H168.516V332.387H168.624C169.296 332.435 169.956 332.589 170.58 332.843L170.556 332.891Z",
    fill: "#263238"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M170.556 332.891C170.444 332.903 170.332 332.903 170.22 332.891H168.516V332.387H168.624C169.296 332.435 169.956 332.589 170.58 332.843L170.556 332.891Z",
    fill: "white"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M170.208 332.915H157.2H140.568L140.652 333.083C140.616 333.03 140.584 332.973 140.556 332.915H136.68C137.796 332.735 139.02 332.555 140.28 332.411L141.084 332.315C142.152 332.183 143.244 332.075 144.324 331.991H144.624C146.568 331.835 148.5 331.715 150.444 331.631H150.888C151.812 331.631 152.724 331.559 153.636 331.547C154.992 331.547 156.348 331.547 157.704 331.547H158.484C159.48 331.547 160.488 331.547 161.484 331.607L162.6 331.703C162.924 331.703 163.236 331.763 163.56 331.775C164.448 331.871 165.312 331.979 166.14 332.099L167.34 332.279L167.928 332.375L168.48 332.459H168.576C169.088 332.542 169.587 332.687 170.064 332.891L170.208 332.915Z",
    fill: "#263238"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M162.996 332.928H157.2H145.8C145.378 332.636 144.977 332.315 144.6 331.968L144.072 331.476C144.859 330.814 145.501 329.997 145.956 329.076C147.396 326.244 147.156 322.728 146.784 320.22C146.628 319.02 146.436 318.108 146.388 317.544C146.383 317.48 146.383 317.416 146.388 317.352C146.388 317.172 146.388 317.052 146.46 317.016L146.688 317.1L147.252 317.304L147.528 317.4L157.056 320.82C156.984 321.132 156.924 321.444 156.864 321.756C156.804 322.068 156.744 322.392 156.708 322.704L156.636 323.292C156.589 323.714 156.565 324.139 156.564 324.564C156.548 325.374 156.649 326.182 156.864 326.964C157.074 327.752 157.46 328.482 157.992 329.1C158.15 329.297 158.326 329.478 158.52 329.64C159.646 330.547 160.984 331.154 162.408 331.404C162.471 331.508 162.528 331.616 162.576 331.728C162.778 332.103 162.919 332.508 162.996 332.928Z",
    fill: "#EBB376"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M156.888 326.878C153.288 326.134 149.184 323.638 148.104 320.566C147.686 319.506 147.407 318.397 147.276 317.266L157.08 320.782C156.517 322.767 156.451 324.861 156.888 326.878Z",
    fill: "black"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M145.056 305.601C145.716 313.305 145.728 317.853 149.748 321.693C155.748 327.501 165.204 323.721 166.872 315.957C168.36 308.973 167.004 297.537 159.36 294.657C156.753 293.649 153.853 293.714 151.294 294.838C148.735 295.963 146.725 298.055 145.704 300.657C145.106 302.232 144.884 303.925 145.056 305.601Z",
    fill: "#EBB376"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M156.84 307.462C156.84 308.086 157.188 308.578 157.608 308.578C158.028 308.578 158.34 308.038 158.328 307.378C158.316 306.718 157.956 306.25 157.548 306.262C157.14 306.274 156.828 306.814 156.84 307.462Z",
    fill: "#263238"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M163.944 307.271C163.944 307.895 164.304 308.399 164.712 308.387C165.12 308.375 165.444 307.859 165.432 307.187C165.42 306.515 165.072 306.059 164.664 306.071C164.256 306.083 163.932 306.683 163.944 307.271Z",
    fill: "#263238"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M161.688 307.641C162.491 309.543 163.549 311.327 164.832 312.945C164.41 313.265 163.922 313.488 163.403 313.598C162.884 313.708 162.348 313.702 161.832 313.581L161.688 307.641Z",
    fill: "#D58745"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M154.572 305.207C154.638 305.218 154.705 305.21 154.766 305.185C154.828 305.159 154.881 305.117 154.92 305.063C155.186 304.67 155.544 304.347 155.962 304.122C156.379 303.896 156.845 303.775 157.32 303.767C157.418 303.768 157.512 303.73 157.584 303.664C157.655 303.597 157.698 303.505 157.704 303.407C157.702 303.31 157.664 303.218 157.597 303.147C157.531 303.076 157.441 303.032 157.344 303.023C156.758 303.031 156.183 303.182 155.669 303.462C155.155 303.742 154.716 304.143 154.392 304.631C154.358 304.664 154.331 304.703 154.312 304.746C154.294 304.79 154.284 304.836 154.284 304.883C154.284 304.931 154.294 304.977 154.312 305.021C154.331 305.064 154.358 305.103 154.392 305.135L154.572 305.207Z",
    fill: "#263238"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M158.964 316.524C158.055 316.47 157.173 316.196 156.394 315.725C155.614 315.255 154.96 314.603 154.488 313.824C154.466 313.778 154.463 313.725 154.478 313.676C154.494 313.627 154.527 313.585 154.572 313.56C154.615 313.538 154.665 313.533 154.712 313.546C154.759 313.56 154.799 313.59 154.824 313.632C155.276 314.342 155.889 314.936 156.612 315.368C157.335 315.799 158.148 316.055 158.988 316.116C159.013 316.118 159.038 316.124 159.061 316.135C159.083 316.146 159.104 316.162 159.12 316.181C159.137 316.2 159.15 316.222 159.158 316.246C159.166 316.27 159.17 316.295 159.168 316.32C159.168 316.345 159.163 316.37 159.153 316.394C159.144 316.417 159.13 316.438 159.112 316.456C159.094 316.474 159.073 316.488 159.05 316.498C159.026 316.507 159.001 316.512 158.976 316.512L158.964 316.524Z",
    fill: "#263238"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M166.932 304.798C166.966 304.813 167.003 304.82 167.04 304.82C167.077 304.82 167.114 304.813 167.148 304.798C167.192 304.778 167.232 304.748 167.264 304.712C167.297 304.676 167.321 304.634 167.337 304.588C167.353 304.542 167.359 304.493 167.356 304.445C167.352 304.396 167.339 304.349 167.316 304.306C167.059 303.777 166.678 303.318 166.206 302.967C165.734 302.617 165.185 302.384 164.604 302.29C164.506 302.283 164.409 302.314 164.333 302.377C164.257 302.439 164.208 302.528 164.196 302.626C164.19 302.723 164.221 302.818 164.284 302.892C164.346 302.966 164.436 303.013 164.532 303.022C164.988 303.111 165.418 303.305 165.786 303.588C166.155 303.871 166.453 304.236 166.656 304.654C166.687 304.698 166.728 304.735 166.777 304.76C166.825 304.785 166.878 304.798 166.932 304.798Z",
    fill: "#263238"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M147.228 311.902C147.228 311.902 151.236 304.978 149.22 299.386C151.816 298.678 154.581 298.943 156.996 300.13C156.923 299.233 156.746 298.347 156.468 297.49C156.468 297.49 163.368 297.046 167.352 300.958C166.977 298.415 165.775 296.067 163.932 294.274C164.926 293.975 165.986 293.975 166.98 294.274C166.98 294.274 160.704 289.222 150.852 292.102C141 294.982 137.928 300.958 140.184 309.742C142.44 318.526 147.192 320.446 147.192 320.446C147.192 320.446 145.224 313.762 145.656 312.262C146.088 310.762 147.228 311.902 147.228 311.902Z",
    fill: "#263238"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M141.792 314.206C142.878 315.819 144.555 316.94 146.46 317.326C148.992 317.818 150.06 315.502 149.172 313.21C148.38 311.194 146.112 308.41 143.652 308.998C143.116 309.123 142.62 309.38 142.21 309.746C141.799 310.113 141.487 310.576 141.301 311.094C141.116 311.613 141.064 312.169 141.15 312.713C141.236 313.256 141.457 313.77 141.792 314.206Z",
    fill: "#EBB376"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M153.792 332.759L154.236 332.927H140.556C140.46 332.759 140.376 332.591 140.292 332.411L144.684 328.199C145.107 328.523 145.548 328.823 146.004 329.099C147.576 330.051 149.212 330.893 150.9 331.619C151.404 331.847 151.932 332.063 152.496 332.291L153.792 332.759Z",
    fill: "#263238"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M163.572 331.727V332.927H157.2L157.284 332.735C157.457 332.349 157.594 331.947 157.692 331.535C157.698 331.512 157.698 331.487 157.692 331.463C157.752 331.199 157.812 330.923 157.86 330.611C157.935 330.075 157.976 329.533 157.98 328.991C157.98 328.595 157.98 328.163 157.98 327.695L163.572 331.727Z",
    fill: "#263238"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M158.496 331.5C158.411 331.916 158.274 332.319 158.088 332.7V332.88H157.2L157.296 332.688C157.469 332.302 157.606 331.9 157.704 331.488C157.704 331.488 157.704 331.488 157.704 331.416C157.777 331.136 157.833 330.851 157.872 330.564C157.957 330.032 158.002 329.495 158.004 328.956C158.004 328.548 158.004 328.116 158.004 327.66C158.329 328.222 158.525 328.849 158.58 329.496C158.661 330.164 158.633 330.841 158.496 331.5Z",
    fill: "black"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M244.98 307.089H188.4C188.205 307.089 188.012 307.05 187.832 306.976C187.652 306.901 187.489 306.791 187.352 306.652C187.215 306.514 187.106 306.35 187.033 306.17C186.959 305.989 186.922 305.796 186.924 305.601C186.924 305.21 187.079 304.834 187.356 304.557C187.633 304.281 188.008 304.125 188.4 304.125H244.944C245.336 304.125 245.713 304.28 245.992 304.557C246.271 304.833 246.429 305.208 246.432 305.601C246.432 305.989 246.28 306.363 246.009 306.641C245.738 306.919 245.368 307.08 244.98 307.089Z",
    fill: "white"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M226.8 292.869H189.06C188.529 292.909 188.032 293.149 187.67 293.539C187.308 293.93 187.107 294.443 187.107 294.975C187.107 295.508 187.308 296.021 187.67 296.411C188.032 296.802 188.529 297.041 189.06 297.081H226.8C227.09 297.103 227.381 297.065 227.656 296.969C227.93 296.873 228.182 296.722 228.395 296.524C228.608 296.326 228.778 296.087 228.895 295.82C229.011 295.554 229.071 295.266 229.071 294.975C229.071 294.685 229.011 294.397 228.895 294.13C228.778 293.864 228.608 293.624 228.395 293.427C228.182 293.229 227.93 293.077 227.656 292.981C227.381 292.886 227.09 292.847 226.8 292.869Z",
    fill: "white"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M222.18 313.198H188.4C188.008 313.198 187.633 313.043 187.356 312.766C187.079 312.489 186.924 312.114 186.924 311.722C186.922 311.528 186.959 311.334 187.033 311.154C187.106 310.973 187.215 310.809 187.352 310.671C187.489 310.533 187.652 310.423 187.832 310.348C188.012 310.273 188.205 310.234 188.4 310.234H222.144C222.539 310.234 222.917 310.391 223.196 310.67C223.475 310.949 223.632 311.328 223.632 311.722C223.629 312.109 223.476 312.479 223.205 312.754C222.934 313.03 222.566 313.189 222.18 313.198Z",
    fill: "white"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M353.064 448.31C353.064 448.31 358.284 441.59 365.256 441.59C372.228 441.59 377.82 448.31 377.82 448.31H372.72C370.861 445.896 368.224 444.201 365.256 443.51C360.552 442.598 357.552 448.31 357.552 448.31H353.064Z",
    fill: "#263238"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M399.348 447.133H338.22C334.946 447.133 332.292 449.787 332.292 453.061V496.357C332.292 499.631 334.946 502.285 338.22 502.285H399.348C402.622 502.285 405.276 499.631 405.276 496.357V453.061C405.276 449.787 402.622 447.133 399.348 447.133Z",
    fill: "#263238"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M405.276 453.445V495.973C405.276 496.801 405.113 497.621 404.795 498.387C404.478 499.152 404.013 499.847 403.427 500.432C402.84 501.017 402.145 501.481 401.379 501.797C400.613 502.113 399.793 502.274 398.964 502.273H338.616C337.788 502.274 336.967 502.113 336.202 501.797C335.436 501.481 334.74 501.017 334.154 500.432C333.567 499.847 333.102 499.152 332.785 498.387C332.468 497.621 332.304 496.801 332.304 495.973V453.445C332.304 451.771 332.969 450.165 334.153 448.982C335.337 447.798 336.942 447.133 338.616 447.133H398.964C400.638 447.133 402.244 447.798 403.427 448.982C404.611 450.165 405.276 451.771 405.276 453.445Z",
    fill: "white"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M400.56 453.445V495.973C400.56 496.801 400.397 497.621 400.079 498.387C399.762 499.152 399.297 499.847 398.711 500.432C398.124 501.017 397.429 501.481 396.663 501.797C395.897 502.113 395.077 502.274 394.248 502.273H338.616C337.788 502.274 336.967 502.113 336.202 501.797C335.436 501.481 334.74 501.017 334.154 500.432C333.567 499.847 333.102 499.152 332.785 498.387C332.468 497.621 332.304 496.801 332.304 495.973V453.445C332.304 451.771 332.969 450.165 334.153 448.982C335.337 447.798 336.942 447.133 338.616 447.133H394.248C395.922 447.133 397.528 447.798 398.711 448.982C399.895 450.165 400.56 451.771 400.56 453.445Z",
    fill: "white"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M402 447.913C400.833 448.502 399.852 449.405 399.167 450.519C398.483 451.634 398.122 452.917 398.124 454.225V476.641C398.124 477.014 398.051 477.383 397.908 477.727C397.764 478.072 397.555 478.384 397.29 478.648C397.026 478.911 396.713 479.119 396.368 479.261C396.023 479.402 395.653 479.474 395.28 479.473H333.432C333.059 479.476 332.69 479.405 332.345 479.264C332 479.123 331.686 478.914 331.423 478.651C331.159 478.387 330.95 478.073 330.809 477.728C330.668 477.383 330.597 477.014 330.6 476.641V454.225C330.599 453.293 330.781 452.37 331.137 451.509C331.493 450.648 332.015 449.865 332.674 449.207C333.333 448.548 334.115 448.025 334.976 447.669C335.838 447.314 336.76 447.131 337.692 447.133H398.964C400.026 447.133 401.07 447.402 402 447.913Z",
    fill: "#263238"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M402 447.913C400.833 448.502 399.852 449.405 399.167 450.519C398.483 451.634 398.122 452.917 398.124 454.225V476.641C398.124 477.014 398.051 477.383 397.908 477.727C397.764 478.072 397.555 478.384 397.29 478.648C397.026 478.911 396.713 479.119 396.368 479.261C396.023 479.402 395.653 479.474 395.28 479.473H333.432C333.059 479.476 332.69 479.405 332.345 479.264C332 479.123 331.686 478.914 331.423 478.651C331.159 478.387 330.95 478.073 330.809 477.728C330.668 477.383 330.597 477.014 330.6 476.641V454.225C330.599 453.293 330.781 452.37 331.137 451.509C331.493 450.648 332.015 449.865 332.674 449.207C333.333 448.548 334.115 448.025 334.976 447.669C335.838 447.314 336.76 447.131 337.692 447.133H398.964C400.026 447.133 401.07 447.402 402 447.913Z",
    fill: "white"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M359.46 477.938H364.176V485.222C364.176 485.513 364.119 485.802 364.007 486.071C363.896 486.34 363.732 486.585 363.526 486.791C363.32 486.997 363.075 487.161 362.806 487.273C362.536 487.384 362.248 487.442 361.956 487.442H361.668C361.377 487.442 361.088 487.384 360.819 487.273C360.549 487.161 360.305 486.997 360.098 486.791C359.892 486.585 359.729 486.34 359.617 486.071C359.506 485.802 359.448 485.513 359.448 485.222V477.938H359.46Z",
    fill: "#263238"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M364.476 477.938H359.184C358.754 477.938 358.404 478.287 358.404 478.717V483.217C358.404 483.648 358.754 483.997 359.184 483.997H364.476C364.907 483.997 365.256 483.648 365.256 483.217V478.717C365.256 478.287 364.907 477.938 364.476 477.938Z",
    fill: "white"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M364.176 473.188H359.46V482.691H364.176V473.188Z",
    fill: "#263238"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M491.436 284.102L484.44 291.11C483.36 292.19 484.08 298.658 484.44 300.818C484.8 302.978 493.452 306.926 493.98 306.566C494.508 306.206 496.128 298.718 496.128 298.718L488.928 295.022L493.968 289.13L491.436 284.102Z",
    fill: "#9F5B53"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M490.728 233.691C494.856 235.359 510.864 267.087 510.936 272.823C511.008 278.559 490.728 293.751 490.728 293.751L486.264 289.479C486.264 289.479 501.036 272.091 501.504 269.871C501.972 267.651 485.352 245.871 485.352 245.871L490.728 233.691Z",
    fill: "#4A1FB8"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M510.936 272.82C511.008 278.556 490.728 293.748 490.728 293.748L486.264 289.476C486.264 289.476 501.036 272.088 501.504 269.868C501.756 268.668 497.256 262.104 492.948 256.128C489.072 250.764 485.352 245.892 485.352 245.892L486.924 242.292L490.728 233.652C494.856 235.356 510.864 267.084 510.936 272.82Z",
    fill: "white"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M487.104 286.789L493.284 293.749L490.728 295.645L485.352 289.633L487.104 286.789Z",
    fill: "#4A1FB8"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M492.948 256.129C489.072 250.765 485.352 245.893 485.352 245.893L486.924 242.293C487.212 242.125 487.5 241.969 487.812 241.812C487.812 241.849 493.356 248.113 492.948 256.129Z",
    fill: "black"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M456.372 207.312C455.471 208.796 454.395 210.166 453.168 211.393C453.443 211.831 453.835 212.184 454.299 212.412C454.763 212.641 455.281 212.737 455.796 212.689L456.372 207.312Z",
    fill: "#A24E3F"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M455.352 205.716C455.28 206.556 455.676 207.276 456.24 207.312C456.804 207.348 457.308 206.712 457.368 205.872C457.428 205.032 457.032 204.324 456.48 204.276C455.928 204.228 455.412 204.876 455.352 205.716Z",
    fill: "#2E353A"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M456.3 215.82C456.404 216.227 456.532 216.628 456.684 217.02C457.503 219.322 459 221.322 460.98 222.756C461.482 223.114 462.007 223.438 462.552 223.728C463.992 224.494 465.585 224.929 467.215 225C468.845 225.07 470.47 224.775 471.972 224.136C473.328 223.562 474.554 222.717 475.572 221.652C479.928 217.248 479.82 212.172 480.312 203.568C480.456 201.561 480.084 199.55 479.233 197.726C478.382 195.903 477.078 194.328 475.447 193.149C473.816 191.971 471.91 191.23 469.912 190.995C467.913 190.76 465.888 191.04 464.028 191.808C455.592 195.288 454.44 208.08 456.3 215.82Z",
    fill: "#9F5B53"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M460.98 222.795C461.482 223.153 462.007 223.477 462.552 223.767C463.992 224.533 465.586 224.968 467.216 225.039C468.846 225.109 470.471 224.814 471.972 224.175C471.589 223.14 471.072 222.16 470.436 221.259C467.202 220.85 463.918 221.383 460.98 222.795Z",
    fill: "black"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M478.296 234C474.048 237.852 463.668 236.4 463.668 236.4C463.668 236.4 457.188 234.636 458.556 232.608C462.372 231.972 464.22 230.208 464.988 227.916C465.398 226.503 465.528 225.023 465.372 223.56C465.304 222.755 465.196 221.954 465.048 221.16L477.876 211.656C476.196 217.86 474.144 229.392 478.296 234Z",
    fill: "#9F5B53"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M466.476 188.136C466.476 188.136 464.208 186.744 460.32 190.404C457.056 193.488 460.32 195.96 458.364 199.92C456.408 203.88 459.06 207.78 459.06 207.78C459.06 207.78 460.944 211.836 464.232 211.584C464.232 211.584 466.908 214.824 466.476 218.184C466.044 221.544 470.868 224.184 477.432 224.112C483.996 224.04 481.368 219.924 481.368 219.924C483.27 217.731 484.81 215.247 485.928 212.568C487.251 209.305 487.884 205.803 487.788 202.284C487.848 200.457 487.544 198.636 486.893 196.928C486.242 195.22 485.257 193.659 483.996 192.336C479.616 187.404 469.2 184.92 466.476 188.136Z",
    fill: "#263238"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M465.864 209.713C465.702 210.523 465.362 211.287 464.868 211.95C464.374 212.612 463.739 213.155 463.008 213.541C461.256 214.285 460.104 211.813 460.356 209.221C460.596 206.929 461.784 203.701 463.656 204.133C465.528 204.565 466.476 207.397 465.864 209.713Z",
    fill: "#9F5B53"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M459.036 197.318C459.036 197.318 452.604 191.318 455.532 184.826C458.46 178.334 459.036 184.826 459.036 184.826C459.036 184.826 463.896 180.962 466.476 181.946C469.056 182.93 464.844 185.15 464.844 185.15C464.844 185.15 483.168 181.874 484.8 193.202C486.432 204.53 459.036 197.318 459.036 197.318Z",
    fill: "#263238"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M457.44 203.655C457.373 203.656 457.306 203.642 457.245 203.613C457.185 203.584 457.132 203.54 457.092 203.487C456.993 203.337 456.864 203.21 456.713 203.113C456.562 203.016 456.393 202.951 456.216 202.923C456.103 202.926 455.994 202.885 455.911 202.809C455.828 202.733 455.778 202.627 455.772 202.515C455.765 202.404 455.801 202.295 455.873 202.21C455.944 202.125 456.045 202.071 456.156 202.059C456.478 202.067 456.794 202.153 457.076 202.31C457.358 202.467 457.598 202.689 457.776 202.959C457.812 203.003 457.838 203.055 457.854 203.11C457.87 203.165 457.875 203.223 457.868 203.28C457.861 203.337 457.843 203.392 457.815 203.442C457.787 203.492 457.749 203.535 457.704 203.571C457.628 203.629 457.535 203.658 457.44 203.655Z",
    fill: "#2E353A"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M479.34 233.137L477.444 228.241C477.444 228.241 464.652 225.841 460.32 232.153C455.988 238.465 479.34 233.137 479.34 233.137Z",
    fill: "#4A1FB8"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M445.212 494.044L436.236 494.98L435.78 489.783L434.556 475.635L443.532 474.688L444.888 490.311L445.212 494.044Z",
    fill: "#9F5B53"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M489.996 492.9H481.296L481.224 490.932L481.212 490.692L480.768 478.08L480.756 477.828L480.576 472.992H489.288L489.996 492.9Z",
    fill: "#9F5B53"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M443.532 474.688L444.888 490.311L435.78 489.783L434.556 475.635L443.532 474.688Z",
    fill: "black"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M489.936 491.796H489.924L481.224 490.692H481.212L480.756 478.512H480.768L489.492 479.22L489.924 491.412L489.936 491.796Z",
    fill: "black"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M480.096 492.372H490.656C490.829 492.373 490.997 492.433 491.133 492.542C491.268 492.651 491.362 492.802 491.4 492.972L493.116 500.724C493.183 501.056 493.116 501.402 492.93 501.685C492.743 501.969 492.452 502.167 492.12 502.236C492.028 502.248 491.935 502.248 491.844 502.236C488.424 502.176 485.94 501.96 481.644 501.96C479.004 501.96 471.024 502.248 467.376 502.248C463.728 502.248 463.248 498.648 464.736 498.3C471.444 496.848 476.484 494.82 478.632 492.9C479.036 492.546 479.559 492.357 480.096 492.372Z",
    fill: "#263238"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M435.288 492.098H445.86C446.031 492.102 446.196 492.163 446.329 492.272C446.462 492.381 446.554 492.531 446.592 492.698L448.308 500.438C448.379 500.771 448.315 501.118 448.131 501.404C447.946 501.689 447.656 501.89 447.324 501.962H447.036C443.616 501.902 441.132 501.686 436.836 501.686C434.196 501.686 426.216 501.962 422.568 501.962C418.92 501.962 418.44 498.362 419.928 498.026C426.636 496.574 431.688 494.546 433.824 492.614C434.233 492.27 434.753 492.086 435.288 492.098Z",
    fill: "#263238"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M433.74 488.474H446.496C446.496 488.474 445.452 378.674 459.252 341.582C460.224 353.846 461.316 366.566 462.384 377.162C463.068 383.726 463.728 389.354 464.352 393.65C468.372 421.25 478.512 489.578 478.512 489.578H491.112C491.112 489.578 489.612 424.166 488.124 396.974C486.468 367.478 485.724 302.618 485.724 297.086H439.548C435.156 320.318 423.888 413.246 433.74 488.474Z",
    fill: "#263238"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M459.252 341.535C460.224 353.799 461.316 366.543 462.384 377.139C463.956 361.839 465.888 350.931 465.888 350.931C465.888 350.931 467.688 349.443 472.644 341.535C477.6 333.627 472.644 318.855 472.644 318.855C472.8 332.571 459.252 341.535 459.252 341.535Z",
    fill: "black"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M432.3 484.887L432.924 488.475H447.996V485.163L432.3 484.887Z",
    fill: "#4A1FB8"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M477.06 486.266L478.512 489.59H491.148L491.976 486.266H477.06Z",
    fill: "#4A1FB8"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M486.84 300.159C486.84 300.159 485.064 289.695 487.704 259.179C488.388 251.319 489.36 242.775 490.728 233.691C490.728 233.691 465.636 228.147 448.128 233.691C448.128 233.691 447.408 237.411 446.424 243.735C445.812 247.539 445.116 252.291 444.42 257.751L444.348 258.363C442.608 271.659 439.296 281.511 438.96 299.367L486.84 300.159Z",
    fill: "#4A1FB8"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M487.704 259.202C485.064 289.718 486.84 300.182 486.84 300.182L438.948 299.402C439.248 283.586 441.876 274.046 443.688 262.826C443.916 261.386 444.144 259.91 444.336 258.398L444.408 257.786C444.984 253.262 445.608 249.23 446.1 245.786C446.196 245.078 446.304 244.394 446.412 243.746C447.396 237.422 448.116 233.702 448.116 233.702C465.624 228.158 490.716 233.702 490.716 233.702C489.36 242.774 488.4 251.318 487.704 259.202Z",
    fill: "white"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M448.98 246.326C448.98 246.326 448.548 256.934 443.688 262.802C443.916 261.362 444.144 259.886 444.336 258.374L444.408 257.762C444.984 253.238 445.608 249.206 446.1 245.762C447.076 245.854 448.04 246.043 448.98 246.326Z",
    fill: "black"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M439.488 225.818L443.028 221.366C443.398 220.359 443.894 219.404 444.504 218.522C445.02 218.066 451.452 214.922 451.884 215.114C453.077 217.105 454.15 219.164 455.1 221.282C455.436 221.978 450.3 224.414 448.932 224.762C448.065 224.963 447.158 224.901 446.328 224.582L443.544 229.094",
    fill: "#9F5B53"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M448.284 233.738C444.684 235.202 440.7 239.222 435.084 244.946L444.888 227.246L439.824 224.258C439.824 224.258 419.532 252.638 419.532 256.574C419.532 260.51 424.86 263.594 445.212 252.974C445.212 252.974 450.624 245.234 450.624 240.686C450.733 238.16 449.899 235.683 448.284 233.738Z",
    fill: "#4A1FB8"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M448.284 233.738C444.684 235.202 440.7 239.222 435.084 244.946L444.888 227.246L439.824 224.258C439.824 224.258 419.532 252.638 419.532 256.574C419.532 260.51 424.86 263.594 445.212 252.974C445.212 252.974 450.624 245.234 450.624 240.686C450.733 238.16 449.899 235.683 448.284 233.738Z",
    fill: "white"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M440.352 223.215L446.256 226.539L445.044 230.019L437.232 225.675L440.352 223.215Z",
    fill: "#4A1FB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAccess);
export default __webpack_public_path__ + "static/media/noAccess.950d3b28aba007a52fab11c05784f391.svg";
export { ForwardRef as ReactComponent };